//==========================================
//⚠️ Keep index files under 100 lines!
//Split logic into submodules as needed.
//==========================================
import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useWindowSize } from "../../global/hooks/viewportHooks";
import { useDispatch, useSelector } from "react-redux";
import { fetchSnapshotImage, StreamType } from "../../global/utility/snapshotService";
import { PolygonAnnotation, useGetPolygons } from "../../polygonLib";
import {
  addTags,
  createRoiRequest,
  createRule,
  cvAppRoi,
  deleteRoiRequest,
  editRoiRequest,
  fetchRulesByDeviceIdRequest,
  fetchRulesByDeviceIdSuccess,
  getAllCameraAndFovsDevices,
  getAllCompanionDevices,
  getAllRoiListWithCvApps,
  setRoiPolygon,
  setStatistic,
  showNotificationBanner,
  updateCvAppRoi,
  clearAdvancedConfigAppearances,
  setRoiListWithCvApps,
  updateRoiList,
  saveStreamImageMapping,
  patchWidgetConfig
} from "../../store/actions";
import Toolbar from "./Toolbar";
import "./polygon.css";
import { createSearchParams, Link, useLocation, useNavigate } from "react-router-dom";
import { Button, TextLink, TextLinkCaret } from "@vds/buttons";
import { Icon } from "@vds/icons";
import { Input } from "@vds/inputs";
import { Modal, ModalBody } from "@vds/modals";
import { RadioBoxGroup } from "@vds/radio-boxes";
import { DropdownSelect } from "@vds/selects";
import { Body, Title } from "@vds/typography";
import { ClipLoader } from "react-spinners";
import Rules from "./Roiwidgets/rules";
import Statistics from "./Roiwidgets/statistics";
import EntryAndExit from "./entryandExit";
import { Loader } from "@vds/loaders";
import { listRoi, fetchRoiWithCvApps } from "../../api/RoiServiceManager";
import AdvancedConfiguration from "../../global/components/Modals/AdvancedConfiguration";
import {HOUR_24_MINUTE_FORMAT} from "../../global/constants/statistics.dateConstants";
import {
  CVAPP_CAMERAADJUSTMENT,
  CVAPP_CROWDDENSITY,
  CVAPP_DWELLTIME,
  CVAPP_OBJECTBLUR,
  CVAPP_OBJECTDETECTION,
  CVAPP_PARKINGOCCUPANCYEE,
  CVAPP_PARKINGOCCUPANCYEE_FULLNAME,
  CVAPP_PARKINGOCCUPANCYOA,
  CVAPP_PEOPLE_COUNT_EE,
  CVAPP_PEOPLE_COUNT_EE_FULLNAME,
  CVAPP_PEOPLE_COUNT_OA,
  CVAPP_PERSON_DETECTION,
  CVAPP_PPEUSAGE,
  CVAPP_PROXIMITY,
  CVAPP_SLIPANDFALL,
  CVAPP_UNOBJECTDETECTION,
  CVAPP_VEHICLE_DETECTION,
  CVAPP_VEHICLECOUNTEE,
  CVAPP_VEHICLECOUNTEE_FULLNAME,
  CVAPP_VEHICLECOUNTOA
} from "../../global/constants/cvappConstants";
import { ROI_LABEL_APP_NAME_REGEX } from "../../global/constants/constants";
import { unSubscribeCVApp } from "../../global/utility/Utils";
import { getUISchemaForConfig } from "../../global/utility/configUtils";
import { hasPermission } from "../../global/utility/permissionUtils";
import { transformPolygonData } from "../../global/utility/roiUtils";
import { getPairedCamSnapShotIds } from "../../model/cameraonboardingService";
import { ImageDownloadMedia } from "../../model/mediaService";
import { getCamerabyId, getCameraObjectbyId, getTagName } from "../../model/reportService";
import { adjustPolygonPoints, getPoints, getSplitPoints, getUniquePoints, modifyNestedKeyValues } from "../../utils";
import SeparateTile from "./SeparateTile";
import StandardForm from "./StandardForm";
import List from "./list";
import * as POLYGON_CONSTANTS from "./constants";
import { STORAGE } from "../../global/constants/storageConstants";
import { ADVANCED_CONFIG, ASSOCIATE_STREAMS } from "../../constants/enrolledAppearanceConstants";
import moment from "moment";
import { fetchLicenses } from "../../store/actions/license-actions";
import { breakpoints } from "../../styles/breakpoints";
import { LICENSE_ORIGIN } from "../../global/constants/licensesConstants";
import { deploymentstatusList } from "../../global/utility/statisticsUtil";

const EXCLUDED_CVAPPS = [CVAPP_OBJECTBLUR, CVAPP_CAMERAADJUSTMENT];
const EE_CVAPPS = [
  CVAPP_PEOPLE_COUNT_EE,
  CVAPP_VEHICLECOUNTEE,
  CVAPP_PARKINGOCCUPANCYEE,
  CVAPP_PARKINGOCCUPANCYEE_FULLNAME,
  CVAPP_PEOPLE_COUNT_EE_FULLNAME,
  CVAPP_VEHICLECOUNTEE_FULLNAME
];
const isEECvApp = (name) => EE_CVAPPS.includes(name);
const isExcludedOrEECvApp = (name) => !(EXCLUDED_CVAPPS.includes(name) || isEECvApp(name));

const isSpecificCvApp = (arr, cvAppCategory) => {
  if (Array.isArray(arr) && arr.length) {
    return arr.some((i) => i?.category && i?.category.toLowerCase() === cvAppCategory.toLowerCase());
  }
  return false;
};

const AnnotationDraw = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [stateInfo, setStateInfo] = useState(state);
  const cameraId = state?.cameraId;
  const [cvAppData, setCvAppData] = useState(state && Object.keys(state).length ? state.cvapps : []);
  const [advanceDeployParams, setAdvanceDeployParams] = useState({});
  const [standardDeployParams, setStandardDeployParams] = useState({});
  const sku = state?.sku;
  // const videoSource =
  //   Object.keys(state).length && state?.floorImage
  //     ? state?.floorImage
  //     : "./assets/sample.png";

  const [action, setAction] = useState(state && Object.keys(state).length ? state.action : POLYGON_CONSTANTS.ACTION_TYPES.CREATE);
  const [location, setLocation] = useState(state && Object.keys(state).length ? state.location : POLYGON_CONSTANTS.LOCATION_TYPES.CVAPP);
  const [updateData, setUpdateData] = useState(state && Object.keys(state).length ? state.roiUpdateData : []);
  // const updateResponse = useSelector(
  //   (state) => state.polygonRoiReducer.updateResponse
  // );
  let roiPolygonList = useSelector((state) => state.polygonRoiReducer.roiData);
  const allCVAppList = useSelector((state) => state.cvAppReducer.cvAppList) || [];
  const roiResponse = useSelector((state) => state.polygonRoiReducer.roiResponse);
  const roiError = useSelector((state) => state.polygonRoiReducer.roiError);
  const taggedRoiResponse = useSelector((state) => state.polygonRoiReducer.taggedRoiResponse);
  const taggedAddTagRoiResponse = useSelector((state) => state.polygonRoiReducer.taggedAddTagRoiResponse);
  const { activeSession } = useSelector((state) => state.sessionReducer.activeSession);
  const statisticDatas = useSelector((state) => state.polygonRoiReducer.statisticData);
  const ruleSuccess = useSelector((state) => state.polygonRoiReducer.rulesSuccess);
  const cameraList = useSelector((state) => state.deviceReducer.cameraList);
  const fovList = useSelector((state) => state.deviceReducer.fovList);
  const cvAppRoiLoading = useSelector((state) => state.polygonRoiReducer.cvAppRoiLoading);
  const widgetConfig = useSelector((state) => state.widgetReducer.widgetConfig);
  const selectedFovCamera = useMemo(() => {
    return cameraList.filter((m) => {
      return m.id == stateInfo?.cameraId;
    })[0];
  }, [cameraList, stateInfo?.cameraId]);
  const tagIdList = useSelector((state) => {
    return state.sitesReducer.tagIdList;
  });
  const [isCvappDeploymentUpdated, setIsCvappDeploymentUpdated] = useState(false);
  let rulesList = useSelector((state) => state.polygonRoiReducer.rulesByDeviceId) || [];
  const [isAdvanceConfigTampered, setIsAdvanceConfigTampered] = useState(false);
  const [isStandardConfigTampered, setIsStandardConfigTampered] = useState(false);
  const { deletePolygons } = useGetPolygons();
  const [cvAppCount, setcvAppCount] = useState(0);
  const [error, setError] = useState("");
  const [ruleRes, setRuleRes] = useState(false);
  const [selectedRoi, setSelectedRoi] = useState([]);
  //const cvApps = state;//sessionStorage.getItem("cvApps");
  const [maxPolygons, setMaxPolygons] = useState(1);
  const [selectedIndex, setSelectedIndex] = useState("");
  const [show, setShow] = useState(false);
  const [caShow, setCaShow] = useState(false);
  const [radioGroups, setRadioGroups] = useState([]);
  const [eepolygons, setEePolygons] = useState([]);
  const [eepoints, setEEPoints] = useState([]);
  const [isFinished, setIsFinished] = useState(false);
  const [isErrorInAdvanceConfig, setIsErrorInAdvanceConfig] = useState(false);
  const [isErrorInStandardConfig, setIsErrorInStandardConfig] = useState(false);
  const [ErrorInFormInput, setErrorInFormInput] = useState([]);
  const [selectRadioBox, setSelectRadioBox] = useState(POLYGON_CONSTANTS.RADIO_BOX_OPTIONS.FULL_SCREEN);
  const cvAppName = cvAppData[cvAppCount]?.value;
  const cvappid = cvAppData[cvAppCount]?.cvappid;
  const cvappGroup = cvAppData[cvAppCount]?.title;
  const roiLabel = `ROI${maxPolygons}-${cvappGroup}-${cvAppName}`;
  const [name, setName] = useState(state?.action == POLYGON_CONSTANTS.ACTION_TYPES.UPDATE ? stateInfo.roiUpdateData[0]?.name : roiLabel);
  let navigate = useNavigate();
  const [showFinish, setShowFinish] = useState(true);
  const [advancedData, setAdvancedData] = useState({
    config: {
      [ADVANCED_CONFIG.DEPLOY_PARAMETERS]: {}
    }
  });
  const [standardAdvancedData, setStandardAdvancedData] = useState({
    config: {
      [ADVANCED_CONFIG.DEPLOY_PARAMETERS]: {}
    }
  });

  const [schemaData, setSchemaData] = useState({});
  const [originalSchemaData, setOriginalSchemaData] = useState({});
  const [standardSchemaData, setStandardSchemaData] = useState({});
  const [isShowAdvancedConfig, setIsShowAdvancedConfig] = useState(true);
  const [deployParamsForUpdate, setDeployParamsForUpdate] = useState({});

  const canvasRef = useRef(null);
  const imageRef = useRef(null);

  // Responsive canvas sizing: canvas/stage width scales with the viewport.
  const { width: viewportWidth } = useWindowSize();
  const isModalFullScreen = (viewportWidth ?? 1400) < parseInt(breakpoints.tablet);
  const btnSize = viewportWidth <= 767 ? "small" : "large";
  // const videoSource = cvAppData[cvAppCount]?.floorImage
  //   ? cvAppData[cvAppCount]?.floorImage
  //   : "./assets/sample.png";
  // const [image, status] = useImage(videoSource);
  const initialData = POLYGON_CONSTANTS.getInitialData(roiLabel, cvappGroup, cvAppName);
  const [roiPolygons, setRoiPolygons] = useState([]);
  const [polygonsPoints, setPolygonsPoints] = useState([]);
  const [individual, setIndividual] = useState([]);
  const [visibility, setVisibility] = useState();
  const [tagSaveStatus, setTagSaveStatus] = useState(false);
  const [netCountWithTagList, setNetCountWithTagList] = useState([]);
  const [initData, setInitData] = useState(
    state?.action == POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && !EXCLUDED_CVAPPS.includes(cvAppName) ? state?.roiList : []
  );
  const [roiId, setRoiId] = useState(state?.action == POLYGON_CONSTANTS.ACTION_TYPES.UPDATE ? (state?.roiList && state?.roiList.length > 0 ? state?.roiList[0]?.roiId : "") : "");
  const [showLabel, setShowLabel] = useState(false);
  const [showThambnail, setShowThambnail] = useState(false);
  const [deleteState, setDeleteState] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const pageRef = useRef(null);
  const [submittedData, setSubmittedData] = useState(selectedFovCamera?.tagids);
  let [selectId, setSelectId] = useState([]);
  const [statisticOpen, setStatisticOpen] = useState(false);
  const [appChangeOpen, setappChangeOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalRuleOpen, setIsModalRuleOpen] = useState(false);
  const [disbleRule, setDisableRule] = useState(true);
  const [minMaxXY, setminMaxXY] = useState({});
  const [tagIds, setTagids] = useState(
    cameraList.filter((m) => {
      return m?.id == stateInfo?.cameraId;
    })[0]?.tagids
  );
  const [roiStatsTagIds, setRoiStatsTagIds] = useState(
    cameraList.filter((m) => {
      return m?.id == stateInfo?.cameraId;
    })[0]?.tagids
  );
  const [selectCvIndex, setSelectedCvIndex] = useState(0);
  const [selectedRoiId, setSelectedRoiId] = useState("");
  const [eeRoiIds, setEeRoiIds] = useState([]);
  const [selectStatistic, setSelectStatistic] = useState([roiLabel]);
  const [rulesLists, setRulesLists] = useState([]);
  const [zoneType, setZoneType] = useState("");
  const [selectedRule, setSelectedRule] = useState({});
  const [ruleDetails, setRuleDetails] = useState(false);
  const [checkRule, setCheckRule] = useState(false);
  const [clickStatus, setClickStatus] = useState(false);
  const [successMeg, setSuccessMeg] = useState("");
  const [createNotification, setCreateNotification] = useState(false);
  const [clearRoi, setClearRoi] = useState(false);
  const [deploymentId, setDeploymentId] = useState("");
  const [siteId, setSiteId] = useState(Array.isArray(selectedFovCamera?.siteids) ? selectedFovCamera?.siteids[0] : "");
  const [fullRoiPolygonList, setFullRoiPolygonList] = useState([]);
  const advanceConfigRef = useRef(null);
  const hasReopenedModalRef = useRef(false);
  const [isPolygonExceedImageBoundary, setIsPolygonExceedImageBoundary] = useState (false);

  let zone1defaultColor = POLYGON_CONSTANTS.DEFAULT_COLORS.ZONE1;
  let zone2defaultColor = POLYGON_CONSTANTS.DEFAULT_COLORS.ZONE2;
  let noZoneColor = POLYGON_CONSTANTS.DEFAULT_COLORS.NO_ZONE;
  //Entry Exit Color code:
  const [zone2Color, setZone2Color] = useState(zone2defaultColor);
  const [zone1Color, setZone1Color] = useState(zone1defaultColor);
  const [lineColor, setLineColor] = useState("#ffffff");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const requiredParamsObject = () => {
    const cvAppList = allCVAppList;
    const cvApp = cvAppList.find((i) => i?.id === cvappid);
    if (cvApp) {
      const required = cvApp?.configtemplate?.schema?.properties?.[ADVANCED_CONFIG.DEPLOY_PARAMETERS]?.required;
      const obj = {};
      if (Array.isArray(required) && required.length > 0) {
        required.map((i) => {
          obj[i] = cvApp?.configtemplate?.schema?.properties?.[ADVANCED_CONFIG.DEPLOY_PARAMETERS]?.properties?.[i]?.default ?? null;
        });
        return obj;
      } else {
        return {};
      }
    }
    return {};
  };

  const [polygonStyle, setPolygonStyle] = useState({
    // vertexRadius: 6,
    lineColor: "#9B0606",
    fillColor: "#c51b1b80", //"#37f71139",
    vertexColor: "#ff0000",
    // vertexStrokeWidth: 2
    vertexRadius: 6,
    // lineColor: '#1ea703',
    // fillColor: '#37f71139',
    // vertexColor: '#ff0000',
    vertexStrokeWidth: 2
  });
  const imageSize = {
    width: 100,
    height: 65
  };
  const [isAlertEdited, setIsAlertEdited] = useState(false);
  const isDisabled = (rulesLists, submittedData, statisticDatas, category) => {
    const ruleClone = rulesLists?.filter((rule) => rule.action === POLYGON_CONSTANTS.ACTION_TYPES.CREATE);
    const baseCondition = polygonsPoints && polygonsPoints.length && action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE;
    const excludedApps = !EXCLUDED_CVAPPS.includes(cvAppName);
    if ((isAdvanceConfigTampered || isStandardConfigTampered) && action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {
      return false;
    }
    if (standardAdvancedData?.config?.["deploy-parameters"]?.objects?.length === 0) {
      return true;
    }
    if (checkIfEntryExit() && !isPolygonExceedImageBoundary && statisticDatas?.length === 2 && eepolygons.length && action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && category === POLYGON_CONSTANTS.CATEGORY_TYPES.STATISTICS_APPS) {
      return false;
    }else if (checkIfEntryExit() && !isPolygonExceedImageBoundary && action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && eepolygons.length && isRoiEdited) {
      return false;
    } else if (checkIfEntryExit() && !isPolygonExceedImageBoundary && action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && eepolygons.length && isStatisticsEdited && category === POLYGON_CONSTANTS.CATEGORY_TYPES.STATISTICS_APPS) {
      return false;
    } else if (
      polygonsPoints &&
      polygonsPoints.length &&
      statisticDatas?.length &&
      action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE &&
      category === POLYGON_CONSTANTS.CATEGORY_TYPES.STATISTICS_APPS &&
      cvAppName !== CVAPP_PEOPLE_COUNT_EE &&
      cvAppName !== CVAPP_VEHICLECOUNTEE &&
      cvAppName !== CVAPP_PARKINGOCCUPANCYEE &&
      cvAppName !== CVAPP_PARKINGOCCUPANCYEE_FULLNAME &&
      cvAppName !== CVAPP_PEOPLE_COUNT_EE_FULLNAME &&
      cvAppName !== CVAPP_VEHICLECOUNTEE_FULLNAME 
    ) {
      return false;
    } else if (
      polygonsPoints &&
      polygonsPoints.length &&
      statisticDatas?.length &&
      isStatisticsEdited &&
      action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE &&
      category === POLYGON_CONSTANTS.CATEGORY_TYPES.STATISTICS_APPS &&
      !checkIfEntryExit()
    ) {
      return false;
    } else if (polygonsPoints && polygonsPoints.length && ruleClone?.length && action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {
      return false;
    } else if (polygonsPoints && polygonsPoints.length && ruleClone?.length && category !== POLYGON_CONSTANTS.CATEGORY_TYPES.STATISTICS_APPS) {
      return false;
    } else if (cvAppName == CVAPP_OBJECTBLUR && action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {
      return false;
    } else if (
      (baseCondition && isRoiEdited && excludedApps && !isPolygonExceedImageBoundary) || (baseCondition && isFinished && excludedApps)
    ) {
      return false;
    } else if (isAlertEdited) {
      return false;
    }
     else {
      return true;
    }
  };
  const [originalImageSize, setOriginalImageSize] = useState(POLYGON_CONSTANTS.ORIGINAL_IMAGE_SIZE);
  const checkPolygonExceedImageBoundary = () =>{
     if(checkIfEntryExit() && isPolygonExceedImageBoundary){
      return true;
    }else {
      return false;
    }
    
  }
  useEffect(() => {
    const [origW, origH] = POLYGON_CONSTANTS.ORIGINAL_IMAGE_SIZE;
    // sidebar icon-strip = 60px (--hamburger-width), ContentWrapper padding and canvas container padding from CSS
    const contentPad =
      viewportWidth >= parseInt(breakpoints.tablet)
        ? 64
        : viewportWidth >= parseInt(breakpoints.mobileLg)
          ? 40
          : viewportWidth >= parseInt(breakpoints.mobileMd)
            ? 32
            : 24;
    const canvasPad = viewportWidth >= parseInt(breakpoints.tablet) ? 64 : viewportWidth >= parseInt(breakpoints.mobileMd) ? 32 : 24;
    const availW = viewportWidth - 60 - contentPad - canvasPad;
    if (availW > 0 && availW < origW) {
      setOriginalImageSize([availW, Math.round(origH * (availW / origW))]);
    } else if (availW >= origW) {
      setOriginalImageSize(POLYGON_CONSTANTS.ORIGINAL_IMAGE_SIZE);
    }
  }, [viewportWidth]);
  const [texts, setTexts] = useState(POLYGON_CONSTANTS.TEXT_DEFAULTS);
  const [rectangles, setRectangles] = useState(POLYGON_CONSTANTS.RECTANGLE_DEFAULTS);
  const [circles, setCircles] = useState(POLYGON_CONSTANTS.CIRCLE_DEFAULTS);
  const [isRoiEdited, setIsRoiEdited] = useState(false);
  const [isStatisticsEdited, setIsStatisticsEdited] = useState(false);
  //to close banner on component unmount
  useEffect(() => {
    return () => {
      dispatch(showNotificationBanner({ showNotification: false }))
    };
  }, []);

  const openRuleModal = (type = "") => {
    if (!hasPermission(POLYGON_CONSTANTS.PERMISSION_TYPES.ALERTS, POLYGON_CONSTANTS.PERMISSION_TYPES.CREATE)) {
      showPermissionsBanner();
    } else {
      setZoneType(type);
      setCheckRule(true);
      setIsModalOpen(true);
    }
  };
  const closeRuleRoiModal = () => {
    setIsModalRuleOpen(false);
  };
  const closeRuleModal = (type) => {
    setIsModalOpen(false);
    if (type === "open-create") {
      setIsModalRuleOpen(true);
    } else {
      setIsModalRuleOpen(false);
    }
  };

  const [rulesListLoading, setRulesListLoading] = useState(false);

  const handleRuleResp = (response) => {
    if (response === true) {
      setIsModalOpen(false);
      setRulesListLoading(true);
    }
  };
  const [loading, setLoading] = useState(false);
  const [isRoiListFetching, setIsRoiListFetching] = useState(false);
  const streamId = Array.isArray(state?.FOVId) ? state?.FOVId[0] : state?.FOVId;
  
  const reducerPairedImages = useSelector((state) => state.imagesReducer.streamImages);
  const [floorImage, setFloorImage] = useState(reducerPairedImages.find( f => f.id === streamId)?.imageUrl || "");
  const reducerUnpairedImages = useSelector((state) => state.imagesReducer.unpairedImages);
  const reducerStreamList = useSelector((state) => state.deviceReducer.fovList);
  const reducerUnpairedCameraList = useSelector((state) => state.deviceReducer.discoveredCamerasList);

  const getSnapshot = async () => {
    const reduxStore = {
      activeSession,
      reducerPairedImages,
      reducerUnpairedImages,
      reducerStreamList,
      reducerUnpairedCameraList,
      dispatch
    };

    try {
      const result = await fetchSnapshotImage(state?.FOVId, cameraId, StreamType.PAIRED_CAMERA, state?.companionId, reduxStore);

      setFloorImage(result.imageUrl);
    } catch (error) {
      console.error("Failed to fetch snapshot:", error);
    }
  };

  useEffect(() => {
    getSnapshot();
  }, []);
  const undeployCvapp = async () => {
    try {
      const response = unSubscribeCVApp(stateInfo?.deploymentId, activeSession);
      return response;
    } catch (error) {
      setLoading(false);
      console.error("Error downloading image:", error);
    }
  };
  const fetchFloorImage = async (snapshotId, timeStamp) => {
    try {
      setLoading(true);
      const url = await ImageDownloadMedia(snapshotId, activeSession, streamId, "snapshot");
      if(url){
      setFloorImage(url);
      dispatch(saveStreamImageMapping(streamId, url, timeStamp));
      }
    } catch (error) {
      console.error("Error downloading image:", error);
    } finally{
      setLoading(false);
    }
  };
  const checkIfEntryExit = (cvname = "") => {
    const appName = cvname ? cvname : cvAppName;
    if (
      appName === CVAPP_PEOPLE_COUNT_EE ||
      appName === CVAPP_VEHICLECOUNTEE ||
      appName === CVAPP_PARKINGOCCUPANCYEE ||
      appName === CVAPP_PARKINGOCCUPANCYEE_FULLNAME ||
      appName === CVAPP_PEOPLE_COUNT_EE_FULLNAME ||
      appName === CVAPP_VEHICLECOUNTEE_FULLNAME
    ) {
      return true;
    }
    return false;
  };
  const handlePairedSnapshot = () => {
    setLoading(true);
    const cameraDetails = getCamerabyId(state?.cameraId);
    getPairedCamSnapShotIds(activeSession, cameraDetails[0]?.qrcode, streamId)
      .then((fovData) => {
        if (fovData && fovData.length > 0 && !fovData[0]?.hasOwnProperty(POLYGON_CONSTANTS.API_RESPONSE_KEYS.ERROR)) {
          fetchFloorImage(fovData[0]?.imageid, fovData[0]?.imagetimestamp);
          // dispatch(fetchAllDevices());
          dispatch(getAllCameraAndFovsDevices());
          dispatch(getAllCompanionDevices());
          dispatch(getAllRoiListWithCvApps());
        } else {
          setLoading(false);
          const notificationInfo = {
            type: POLYGON_CONSTANTS.NOTIFICATION_TYPES.SNAPSHOT_FAIL,
            priority: POLYGON_CONSTANTS.NOTIFICATION_PRIORITIES.CRITICAL,
            showNotification: true
          };
          dispatch(showNotificationBanner(notificationInfo));
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const deployCvAppWithRoi = (roiId, deployId) => {
    const deploy = {
      config: {
        [ADVANCED_CONFIG.DEPLOY_PARAMETERS]: {}
      }
    };
    let zones = {};
    const splitData = statisticDatas && statisticDatas.length ? statisticDatas.filter((data) => data.groupName === roiLabel) : [];
    if (eepolygons && eepolygons.length > 0 && splitData.length > 0) {
      const zone1 = splitData?.filter((data) => data.eeAppStatus === POLYGON_CONSTANTS.ZONE_TYPES.ZONE1 && Array.isArray(data.tags) && data.tags.length > 0);
      const zone2 = splitData?.filter((data) => data.eeAppStatus === POLYGON_CONSTANTS.ZONE_TYPES.ZONE2 && Array.isArray(data.tags) && data.tags.length > 0);
      let object = {};
      zones = {
        zone1: zone1[0]?.tags?.length && zone1[0]?.tags[0] !== "-1" ? zone1[0]?.tags : [],
        zone2: zone2[0]?.tags?.length && zone2[0]?.tags[0] !== "-1" ? zone2[0]?.tags : [],
        ...object
      };
    }
    var alertParams = {};
    if (rulesLists && rulesLists.length > 0){
      const repetatives = [];
      const precises = undefined;
      let stime  = "";
      let eTime = "";
      const ruleItem = Array.isArray(rulesLists) ? rulesLists[0] : rulesLists;
    rulesLists?.forEach((rule) => { 
      if(rule?.showTimeFrame){
      stime = new Date(rule?.starttime ?? rule?.startTime);
      eTime = new Date(rule?.endtime ?? rule?.endTime);
      repetatives.push({"days":rule?.timeFrame,
            "start_time":moment(stime).format(HOUR_24_MINUTE_FORMAT),
            "end_time":moment(eTime).format(HOUR_24_MINUTE_FORMAT),
            "time_zone": rule?.timeZone ?? rule?.time_zone});
            
      // precises.push({"start_time": Math.floor(Date.now(stime) / 1000),
      //    "end_time":Math.floor(Date.now(eTime) / 1000)}); 
      }  
    });  
   alertParams = {"schedule":
      {
         "repetitive":repetatives,
          "precise":precises
        },
        "video_evidence_transmission_cooldown":ruleItem?.addCoolDownPeriod ? ruleItem?.coolPeriodValue : undefined,
        "ignore_video_evidence":!ruleItem?.captureVideoEvidence,
        "transmission_priority":ruleItem?.severity
    };
    }

    const payloadconfig = {
      [ADVANCED_CONFIG.DEPLOY_PARAMETERS]: {
        ...zones,
        ...requiredParamsObject(),
        ...modifyNestedKeyValues(isAdvanceConfigTampered ? advancedData : deploy, ADVANCED_CONFIG.DEPLOY_PARAMETERS)?.config[ADVANCED_CONFIG.DEPLOY_PARAMETERS],
        ...modifyNestedKeyValues(isStandardConfigTampered ? standardAdvancedData : deploy, ADVANCED_CONFIG.DEPLOY_PARAMETERS)?.config[ADVANCED_CONFIG.DEPLOY_PARAMETERS]
      },
      "alert-parameters": stateInfo?.cvapps[cvAppCount]?.category === POLYGON_CONSTANTS.CATEGORY_TYPES.STATISTICS_APPS ? undefined : alertParams
    };

    //Coerce deploy-parameters values to match their schema type (e.g., string, integer)
    const schemaProps = allCVAppList?.find((app) => app?.id === cvappid)
      ?.configtemplate?.schema?.properties?.[ADVANCED_CONFIG.DEPLOY_PARAMETERS]?.properties;
    const coerceDeployParams = (config) => {
      if (!schemaProps || !config[ADVANCED_CONFIG.DEPLOY_PARAMETERS]) return;
      Object.keys(config[ADVANCED_CONFIG.DEPLOY_PARAMETERS]).forEach((key) => {
        const val = config[ADVANCED_CONFIG.DEPLOY_PARAMETERS][key];
        const schemaType = schemaProps[key]?.type;
        if (val !== undefined && val !== null && schemaType) {
          if (schemaType === "string") config[ADVANCED_CONFIG.DEPLOY_PARAMETERS][key] = String(val);
          else if (schemaType === "integer") config[ADVANCED_CONFIG.DEPLOY_PARAMETERS][key] = parseInt(val, 10);
          else if (schemaType === "number") config[ADVANCED_CONFIG.DEPLOY_PARAMETERS][key] = parseFloat(val);
          else if (schemaType === "array") config[ADVANCED_CONFIG.DEPLOY_PARAMETERS][key] = Array.isArray(val) ? val : [];
          else if (schemaType === "boolean") config[ADVANCED_CONFIG.DEPLOY_PARAMETERS][key] = Boolean(val);
        }
      });
    };
    coerceDeployParams(payloadconfig);

    if (action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {
      const payloadconfigs = {
        [ADVANCED_CONFIG.DEPLOY_PARAMETERS]: {
          ...zones,
          // ...deployParamsForUpdate,
          ...requiredParamsObject(),
          ...modifyNestedKeyValues(isAdvanceConfigTampered ? advancedData : deploy, ADVANCED_CONFIG.DEPLOY_PARAMETERS)?.config[ADVANCED_CONFIG.DEPLOY_PARAMETERS],
          ...modifyNestedKeyValues(isStandardConfigTampered ? standardAdvancedData : deploy, ADVANCED_CONFIG.DEPLOY_PARAMETERS)?.config[ADVANCED_CONFIG.DEPLOY_PARAMETERS]
        },
        "alert-parameters": stateInfo?.cvapps[cvAppCount]?.category === POLYGON_CONSTANTS.CATEGORY_TYPES.STATISTICS_APPS ? undefined : alertParams
      };

      //Coerce deploy-parameters values to match their schema type
      coerceDeployParams(payloadconfigs);

      const payload = {
        accountname: activeSession?.accountId,
        resourceidentifier: {
          id: deployId ? deployId : deploymentId ? deploymentId : stateInfo?.deploymentId
        },
        deployment: {
          config: payloadconfigs
        }
      };
      if (isAdvanceConfigTampered || isStandardConfigTampered || isAlertEdited || (checkIfEntryExit() && isStatisticsEdited)) {
        dispatch(updateCvAppRoi(payload));
      }
    } else {
      const cvappId = stateInfo?.cvapps[cvAppCount]?.id ? stateInfo?.cvapps[cvAppCount]?.id : stateInfo?.cvapps[cvAppCount]?.cvappid;
      const payload = {
        accountname: activeSession?.accountId,
        deployment: {
          appid: cvappId,
          deviceid: roiId,
          config: payloadconfig,
          sku: sku,
        }
      };
      dispatch(cvAppRoi(payload));
    }
  };

  const resetToDefault = () => {
    setSchemaData(originalSchemaData);
    setAdvancedData({
      config: {
        [ADVANCED_CONFIG.DEPLOY_PARAMETERS]: {}
      }
    });
    setIsAdvanceConfigTampered(false);
    setErrorInFormInput([]);
  };

  const isRequiredParamsAvailable = (obj) => {
    const cvAppList = allCVAppList;
    const cvApp = cvAppList.find((i) => i?.id === cvappid);
    if (cvApp) {
      const required = cvApp?.configtemplate?.schema?.properties?.[ADVANCED_CONFIG.DEPLOY_PARAMETERS]?.required;
      if (Array.isArray(required) && required.length > 0) {
        return required.every((i) => {
          if (Array.isArray(obj?.config?.[ADVANCED_CONFIG.DEPLOY_PARAMETERS]?.[i])) {
            return obj?.config?.[ADVANCED_CONFIG.DEPLOY_PARAMETERS]?.[i].length !== 0;
          }
          return obj?.config?.[ADVANCED_CONFIG.DEPLOY_PARAMETERS]?.[i] !== "";
        });
      }
    }
    return true;
  };

  useEffect(() => {
    if (isFinished) {
      const polygons = JSON.parse(sessionStorage.getItem("polygonsPoints")) || [];
      const polyLength = polygons.length;
      setPolygonsPoints(polygons.length > 0 ? polygons[polyLength - 1]?.points : []);
    }
  }, [isFinished]);

  useEffect(() => {
    // if(initData && initData.length > 0) {
    setPolygonsPoints(initData && initData.length > 0 ? initData[initData.length - 1]?.points : []);
    // }
  }, [initData]);

  useEffect(() => {
    const schemaData = () => {
      const cvApppList = allCVAppList;
      //change when template will be available
      const configData = cvApppList?.find(
        (item) =>
          item.id ===
          (stateInfo && stateInfo.length && stateInfo?.cvapps[cvAppCount]?.id ? stateInfo?.cvapps[cvAppCount]?.id : stateInfo?.cvapps[cvAppCount]?.cvappid)
      );
      const formPrarameter = configData?.resources?.["advancedparameters-form"] || configData?.resources?.["advancedparameters"] || [];
      return getUISchemaForConfig(configData, formPrarameter, ADVANCED_CONFIG.DEPLOY_PARAMETERS);
    };

    const standardSchema = () => {
      const cvApppList = allCVAppList;
      const configData = cvApppList.find(
        (item) => item.id === (stateInfo?.cvapps[cvAppCount]?.id ? stateInfo?.cvapps[cvAppCount]?.id : stateInfo?.cvapps[cvAppCount]?.cvappid)
      );
      const formParameter = configData?.resources?.["standarparameters-form"] || configData?.resources?.["standarparameters"] || [];

      return getUISchemaForConfig(configData, formParameter, ADVANCED_CONFIG.DEPLOY_PARAMETERS);
    };
    const result = schemaData();
    setSchemaData(result ?? { scemaResourceData: [], scemaTemplateData: [] });

    setOriginalSchemaData(result ?? { scemaResourceData: [], scemaTemplateData: [] });
    setStandardSchemaData(standardSchema() ?? { scemaResourceData: [], scemaTemplateData: [] });

    let deployParamsResult = null;
    let advancedDeployParamsResult = null;

    if (stateInfo?.cvapps[cvAppCount]?.deployments) {
      const getDeploymentParams = () => {
        const deployParamsList = stateInfo?.cvapps[cvAppCount].deployments.filter((f) => f?.status === POLYGON_CONSTANTS.DEPLOYMENT_STATUS.DEPLOYED);

        if (deployParamsList.length > 0) {
          return deployParamsList[0];
        }
      };
      deployParamsResult = getDeploymentParams();

      setDeployParamsForUpdate(getDeploymentParams()?.config?.[ADVANCED_CONFIG.DEPLOY_PARAMETERS]);

      const getAdvancedDeployParams = () => {
        const data = deployParamsResult?.config[ADVANCED_CONFIG.DEPLOY_PARAMETERS];
        const obj = {};
        if (data && Object.keys(data).length > 0) {
          Object.keys(data).forEach((i) => {
            const bool = result.scemaResourceData.some((f) => f.key === i);
            if (bool) {
              obj[i] = data[i];
            }
          });
          return obj;
        }
      };
      advancedDeployParamsResult = getAdvancedDeployParams();
      setAdvanceDeployParams(advancedDeployParamsResult ?? {});
      if (advancedDeployParamsResult && Object.keys(advancedDeployParamsResult).length > 0) {
        const obj = {};
        Object.keys(result?.scemaTemplateData).forEach((key) => {
          if (advancedDeployParamsResult.hasOwnProperty(key)) {
            obj[key] = { ...result.scemaTemplateData[key], default: advancedDeployParamsResult[key] };
          } else {
            obj[key] = { ...result.scemaTemplateData[key] };
          }
        });
        setSchemaData(
          { ...result, scemaTemplateData: obj } ?? {
            scemaResourceData: [],
            scemaTemplateData: []
          }
        );
        setOriginalSchemaData(
          { ...result, scemaTemplateData: obj } ?? {
            scemaResourceData: [],
            scemaTemplateData: []
          }
        );
      }

      const getStandardDeployParams = () => {
        const data = deployParamsResult?.config[ADVANCED_CONFIG.DEPLOY_PARAMETERS];
        const obj = {};
        if (data && Object.keys(data).length > 0) {
          Object.keys(data).forEach((i) => {
            if (standardSchema().scemaResourceData.some((f) => f.key === i)) {
              obj[i] = data[i];
            }
          });
          return obj;
        }
      };
      const standardAdvanceParamsResult = getStandardDeployParams();
      setStandardDeployParams(standardAdvanceParamsResult ?? {});
      const standardResult = standardSchema();
      if (standardAdvanceParamsResult && Object.keys(standardAdvanceParamsResult).length > 0) {
        const obj = {};
        Object.keys(standardResult?.scemaTemplateData).forEach((key) => {
          if (standardAdvanceParamsResult.hasOwnProperty(key)) {
            obj[key] = { ...standardResult.scemaTemplateData[key], default: standardAdvanceParamsResult[key] };
          } else {
            obj[key] = { ...standardResult.scemaTemplateData[key] };
          }
        });
        setStandardSchemaData(
          { ...standardResult, scemaTemplateData: obj } ?? {
            scemaResourceData: [],
            scemaTemplateData: []
          }
        );
      }
    }

    if (result === undefined || result === null || result?.scemaResourceData?.length === 0) {
      setIsShowAdvancedConfig(false);
    } else {
      setIsShowAdvancedConfig(true);
    }

    // Initialize advancedData from deployment params in edit flow

    if (deployParamsResult?.config?.[ADVANCED_CONFIG.DEPLOY_PARAMETERS]) {
      setAdvancedData({
        config: {
          [ADVANCED_CONFIG.DEPLOY_PARAMETERS]: { ...deployParamsResult.config[ADVANCED_CONFIG.DEPLOY_PARAMETERS] }
        }
      });
    } else {
      setAdvancedData({
        config: {
          [ADVANCED_CONFIG.DEPLOY_PARAMETERS]: {}
        }
      });
    }

    // Edit flow: seed standardAdvancedData from the saved deployment config, same as
    // advancedData above. Without this it always resets to {}, which makes
    // StandardForm's own seed-effect treat every field as unset and overwrite the
    // saved obj_with_person/objects values with schema defaults on every modal open.
    if (deployParamsResult?.config?.[ADVANCED_CONFIG.DEPLOY_PARAMETERS]) {
      setStandardAdvancedData({
        config: {
          [ADVANCED_CONFIG.DEPLOY_PARAMETERS]: { ...deployParamsResult.config[ADVANCED_CONFIG.DEPLOY_PARAMETERS] }
        }
      });
    } else {
      setStandardAdvancedData({
        config: {
          [ADVANCED_CONFIG.DEPLOY_PARAMETERS]: {}
        }
      });
    }
    // allCVAppList is included because schemaData()/standardSchema() read from it;
    // omitting it left the effect closing over a stale (possibly empty) list when
    // the CV app list finishes loading after this effect's first run.

    // Placed here so when returning from create/edit appearance, modal opens after savedPayload is restored.
    if (stateInfo?.reopenAdvancedConfig && !hasReopenedModalRef.current && advanceConfigRef.current) {
      hasReopenedModalRef.current = true;
      advanceConfigRef.current.click();
    }
  }, [cvAppCount, allCVAppList]);

  // initialize default method and variable using useEffect
  useEffect(() => {
    const image = imageRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    image.onload = () => {
      canvas.width = image.width;
      canvas.height = image.height;
      context.drawImage(image, 0, 0, image.width, image.height);
      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      const { minX, minY, maxX, maxY } = findMinMaxCoordinates(imageData);
      setminMaxXY({ minX: minX, minY: minY, maxX: maxX, maxY: maxY });
    };
    const findMinMaxCoordinates = (imageData) => {
      const data = imageData.data;
      const width = imageData.width;
      const height = imageData.height;

      let minX = width,
        minY = height,
        maxX = 0,
        maxY = 0;
      let found = false;

      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          const index = (y * width + x) * 4;
          const alpha = data[index + 3];
          if (alpha > 0) {
            found = true;
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
          }
        }
      }
      if (!found) {
        return { minX: null, minY: null, maxX: null, maxY: null };
      }
      return { minX, minY, maxX, maxY };
    };

    radioGroupsetting();
    if ((cvAppData && !cvAppData.length) || !state?.cameraId || state === undefined || state === null) {
      navigate("/devices");
    }
    const cameraDetails = state?.fromAction === "cameraPairing" ? getCameraObjectbyId(state?.cameraId) : getCamerabyId(state?.cameraId);
    //setSiteId(cameraDetails[0]?.customdata?.location?.site?.tag);
  }, []);

  // Group reset
  useEffect(() => {
    radioGroupsetting();
  }, [roiPolygons]);

  useEffect(() => {
    if (ruleDetails) {
    }
  }, [ruleDetails]);

  //Get Update statistic Data
  useEffect(() => {
    if (statisticDatas && statisticDatas.length) {
      const splitData = statisticDatas && statisticDatas.length ? statisticDatas.filter((data) => data.groupName === roiLabel) : [];
      //setTagids(splitData[0]?.tags);
      if (checkIfEntryExit() && splitData.length > 0) {
        const g = splitData
          .map((m) => {
            return m?.tags;
          })
          .flat()
          .filter((tag) => tag && tag !== "-1");

        const uniqueTags = [...new Set(g)];
        setTagids([...uniqueTags]);
        setRoiStatsTagIds([...uniqueTags]);
        setSubmittedData([...uniqueTags]);
        //}
      } else if (splitData.length > 0) {
        if (tagIds && tagIds.indexOf(splitData[0]?.tags) === -1) {
          const rawTags = splitData[0]?.tags;
          const isArr = Array.isArray(rawTags);
          const tagsCopy = isArr ? [...rawTags] : rawTags;
          const submitTags = isArr && Array.isArray(rawTags[0]) ? [...rawTags[0]] : tagsCopy;

          setTagids(tagsCopy);
          setRoiStatsTagIds(isArr ? [...rawTags] : rawTags);
          setSubmittedData(submitTags);
        }
      }
    }
  }, [statisticDatas]);

  //After successfully Create ROI and store the state then process depending methods
  useEffect(() => {
    setOpenModal(false);
    let polygonPoints = matchedPolygon(cvAppCount, true);
    radioGroupsetting();
    if (action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && polygonPoints.length) {
      setDisableRule(false);
      fetchRules(polygonPoints[0], "", "rule");
    } else {
      setRoiPolygon(roiPolygonList);
    }
    const shouldShowCustomArea =
      action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE &&
      taggedRoiResponse?.status !== POLYGON_CONSTANTS.DEPLOYMENT_STATUS.DEPLOYING &&
      !EXCLUDED_CVAPPS.includes(cvAppName);
    handleBoxGroup(shouldShowCustomArea ? POLYGON_CONSTANTS.RADIO_BOX_OPTIONS.CUSTOM_AREA : POLYGON_CONSTANTS.RADIO_BOX_OPTIONS.FULL_SCREEN, polygonPoints);
  }, [roiPolygonList]);

  //Get Updated ROI datas
  useEffect(() => {
    dispatch(setRoiPolygon(updateData));
    setRoiPolygon(updateData);
  }, [updateData]);

  //Alert Success Response
  useEffect(() => {
    if (ruleSuccess && ruleSuccess.length) {
      setLoading(false);
      setRuleDetails(false);
      setOpenModal(false);
      setRuleRes(false);
      setIsAlertEdited(true);
      let meg = POLYGON_CONSTANTS.NOTIFICATION_MESSAGES.ALERT_SUBMITTED;
      if (ruleSuccess[0]?.hasOwnProperty(POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) && ruleSuccess[0]?.update === POLYGON_CONSTANTS.ACTION_TYPES.DELETE) {
        setSuccessMeg(meg);
        setRuleRes(true);
        const notificationInfo = {
          type: POLYGON_CONSTANTS.NOTIFICATION_TYPES.ALERT_DELETED,
          priority: "success",
          data: {
            title: "",
            subTitle: POLYGON_CONSTANTS.NOTIFICATION_MESSAGES.ALERT_DELETED_MESSAGE
          },
          showNotification: true
        };
        dispatch(showNotificationBanner(notificationInfo));
      } else if (!isStatisticsEdited && !isRoiEdited) {
        setSuccessMeg(meg);
        setRuleRes(true);
        setOpenModal(true);
      }
      // if(isStatisticsEdited){
      //   dispatch(addTags(ruleSuccess?.updateResponse?.deviceid, tagIds));
      //   setIsStatisticsEdited(false);
      // }

      // setTimeout(() => {
      //   setRuleRes(true);
      // }, 100);
    }
  }, [ruleSuccess]);

  useEffect(() => {
    if (roiError && roiError.length !== 0) {
      setLoading(false);
      setCreateNotification(false);
      const notificationInfo = {
        type: action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE ? POLYGON_CONSTANTS.NOTIFICATION_TYPES.ROI_UPDATE_FAIL : POLYGON_CONSTANTS.NOTIFICATION_TYPES.ROI_CREATE_FAIL,
        priority: POLYGON_CONSTANTS.NOTIFICATION_PRIORITIES.CRITICAL,
        data: {
          title: "",
          subTitle: action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE 
            ? POLYGON_CONSTANTS.NOTIFICATION_MESSAGES.ROI_UPDATE_FAIL_MESSAGE 
            : POLYGON_CONSTANTS.NOTIFICATION_MESSAGES.ROI_CREATE_FAIL_MESSAGE
        },
        showNotification: true
      };
      dispatch(showNotificationBanner(notificationInfo));
      setIsRoiEdited(action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE ? true : false);
    }
  }, [roiError]);

  //Observe ROI Response
  useEffect(() => {
    if (roiResponse && Object.keys(roiResponse).length && !roiResponse?.hasOwnProperty(POLYGON_CONSTANTS.API_RESPONSE_KEYS.ERROR)) {
      setError("");

      // if(eepolygons && eeRoiIds.length > 2) {
      //   eeRoiIds.push(roiResponse?.id);
      //   setEeRoiIds(eeRoiIds);
      // } else {
      setTagSaveStatus(true);
      if (action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {
        if (taggedRoiResponse?.status === POLYGON_CONSTANTS.DEPLOYMENT_STATUS.DEPLOYING) {
          dispatch(setRoiPolygon(selectedRoi));
        }
        deployCvAppWithRoi(roiResponse?.id);
      } else if (action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {
        if (!isAlertEdited && !checkIfEntryExit()) {
          dispatch(setRoiPolygon(selectedRoi));
          dispatch(addTags(roiResponse?.id, tagIds, siteId, roiStatsTagIds));
        } else if (checkIfEntryExit()) {
          dispatch(setRoiPolygon(selectedRoi));
          if (isStatisticsEdited) {
            deployCvAppWithRoi(roiResponse?.id);
          } else {
            setLoading(false);
            handleModalOpen();
          }
        }
      }

      setShowFinish(false);
      //}
    } else if (roiResponse?.hasOwnProperty(POLYGON_CONSTANTS.API_RESPONSE_KEYS.ERROR) && roiResponse?.hasOwnProperty(POLYGON_CONSTANTS.API_RESPONSE_KEYS.ERROR_DESCRIPTION)) {
      setLoading(false);
      setError(roiResponse.error_description);
      handleModalOpen();
    }
  }, [roiResponse]);

  useEffect(() => {
    if (taggedRoiResponse && Object.keys(taggedRoiResponse).length && !taggedRoiResponse?.hasOwnProperty(POLYGON_CONSTANTS.API_RESPONSE_KEYS.ERROR)) {
      setError("");
      setLoading(false);
      setTagSaveStatus(true);
      if (action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && cvAppName != CVAPP_OBJECTBLUR && rulesList.length > 0) {
        const roid = cvAppName == CVAPP_CAMERAADJUSTMENT ? fullRoiPolygonList.find((f) => f.customdata == undefined).id : roiResponse?.id;

        //if (checkIfEntryExit()) {
        rulesLists?.map((rule, index) => {
          const ruleClone = JSON.parse(JSON.stringify(rule));
          ruleClone.action = ruleClone.action == undefined ? POLYGON_CONSTANTS.ACTION_TYPES.CREATE : ruleClone.action;
          dispatch(
            createRule({
              ...ruleClone,
              ...{
                roiid: roid,
                deploymentid: taggedRoiResponse?.id,
                companionid: state?.companionId
              }
            })
          );
        });
        
      }
      if (action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && checkIfEntryExit() && isStatisticsEdited) {
        if (Array.isArray(tagIds) && !tagIds.includes(siteId)) {
          tagIds.push(siteId);
        }
        dispatch(addTags(roiId, tagIds, siteId, roiStatsTagIds));
      }
      if (!EXCLUDED_CVAPPS.includes(cvAppName) && action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {
        if (Array.isArray(tagIds) && !tagIds.includes(siteId)) {
          tagIds.push(siteId);
        }
        dispatch(addTags(roiResponse?.id, tagIds, siteId, roiStatsTagIds));
        handleModalOpen();
      } else if (EXCLUDED_CVAPPS.includes(cvAppName) && action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {
        setRuleRes(false);
        setOpenModal(true);
        //dispatch(fetchAllDevices());
        dispatch(getAllCameraAndFovsDevices());
        dispatch(getAllCompanionDevices());
        dispatch(getAllRoiListWithCvApps());
        // Clear enrolled appearance data after successful deployment
        dispatch(clearAdvancedConfigAppearances());
      } else if (action == POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {
        setOpenModal(true);
        setIsCvappDeploymentUpdated(true);
        // Clear enrolled appearance data after successful deployment update
        dispatch(clearAdvancedConfigAppearances());
      }

      setCheckRule(false);
      setDisableRule(false);
    } else if (roiResponse?.hasOwnProperty(POLYGON_CONSTANTS.API_RESPONSE_KEYS.ERROR) && roiResponse?.hasOwnProperty(POLYGON_CONSTANTS.API_RESPONSE_KEYS.ERROR_DESCRIPTION)) {
      setLoading(false);
      setError(roiResponse.error_description);
      handleModalOpen();
    }
    // dispatch(getAllRoiListWithCvApps());
  }, [taggedRoiResponse]);

  useEffect(() => {
    if (taggedAddTagRoiResponse && Object.keys(taggedAddTagRoiResponse).length && !taggedAddTagRoiResponse?.hasOwnProperty(POLYGON_CONSTANTS.API_RESPONSE_KEYS.ERROR)) {
      setError("");
      setLoading(false);
      let updatedWidgets = [...widgetConfig];
      if (action == POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {

        const locationDeviceMapping = selectedRoi?.[0]?.deployments?.[0]?.config?.locationDeviceMapping;
        const existingTagId = checkIfEntryExit()
          ? (locationDeviceMapping ? Object.keys(locationDeviceMapping) : [])
          : (cvAppData?.[0]?.tagids || []);
        updatedWidgets = updatedWidgets.filter((widget) => {
          return !(widget?.content?.appName === cvappid && existingTagId?.includes(widget?.content?.location) && !tagIds?.includes(widget?.content?.location));
        });
        dispatch(patchWidgetConfig({ customdata: { widgetconfig: updatedWidgets } }));
        // setRuleRes(true);
        setOpenModal(true);
        // dispatch(fetchAllDevices());
        dispatch(getAllCameraAndFovsDevices());
        dispatch(getAllCompanionDevices());
        dispatch(getAllRoiListWithCvApps());
      }
    } else if (taggedAddTagRoiResponse?.hasOwnProperty(POLYGON_CONSTANTS.API_RESPONSE_KEYS.ERROR) && taggedAddTagRoiResponse?.hasOwnProperty(POLYGON_CONSTANTS.API_RESPONSE_KEYS.ERROR_DESCRIPTION)) {
      setError(taggedAddTagRoiResponse.error_description);
      setLoading(false);
      handleModalOpen();
    }
  }, [taggedAddTagRoiResponse]);

  const handleModalOpen = () => {
    setOpenModal(false);
    setLoading(false);
    setTimeout(() => {
      setOpenModal(true);
    }, POLYGON_CONSTANTS.TIMEOUT_DURATIONS.MODAL_OPEN);
  };

  // Observe Alert Response
  // Fires whenever rulesByDeviceId (rulesList) changes in Redux — covers two scenarios:
  //   1. Unsaved alert added via modal (action="create" item dispatched directly to Redux)
  //   2. Server fetch response after ROI selection or post-save refresh
  useEffect(() => {
    // Reset loading spinner on every rulesList change (set to true on ROI selection in selectedPolygon)
    setRulesListLoading(false);

    if (rulesList && Object.keys(rulesList).length && rulesList?.hasOwnProperty(POLYGON_CONSTANTS.API_RESPONSE_KEYS.ERROR) && rulesList?.hasOwnProperty(POLYGON_CONSTANTS.API_RESPONSE_KEYS.ERROR_DESCRIPTION)) {
      // API error — show error modal and clear list
      setError(rulesList?.error_description);
      setLoading(false);
      setOpenModal(true);
      setRulesLists([]);
    } else {
      if (Array.isArray(rulesList) && rulesList.length > 0) {
        // deviceId = roiId of the currently selected cv app ROI.
        // Used to scope rules to the current ROI only (prevents cross-ROI contamination
        // when multiple cv apps share the same rulesByDeviceId Redux slice).
        const deviceId = cvAppData?.[cvAppCount]?.roiId;

        // rulesForDevice: scopes the list to current ROI.
        // When deviceId is available: include saved rules for this ROI + any unsaved (action="create") rules.
        // When deviceId not yet available (ROI not saved): show only unsaved rules to avoid showing
        // rules from other ROIs before the current ROI has an ID.
        const rulesForDevice = deviceId
          ? rulesList.filter(
              (f) => f.deviceid === deviceId || f.action === POLYGON_CONSTANTS.ACTION_TYPES.CREATE
            )
          : rulesList.filter((f) => f.action === POLYGON_CONSTANTS.ACTION_TYPES.CREATE);

        // hasCreateAction: true when user has added an unsaved alert via the modal
        // (dispatched to Redux with action="create" before ROI is saved to server).
        const hasCreateAction = rulesForDevice.some((rule) => rule && rule.hasOwnProperty("action") && rule.action === POLYGON_CONSTANTS.ACTION_TYPES.CREATE);

        // filteredRules: when adding a new unsaved alert alongside existing saved ones,
        // filter out alerts from previous deployments of the same ROI to avoid stale alerts
        // appearing next to the new one.
        // deploymentId is set by mapDeploymentId() on ROI selection — sourced from live polygonPoints
        // API data, filtered by cvappid + deploymentstatusList (not stale navigation state).
        // When deploymentId is empty (create mode or not yet set), skip this filter — safe fallback.
        // When all alerts are saved (no hasCreateAction), skip filter — newly saved alerts
        // may not have deploymentid populated yet and would be incorrectly excluded.
        const filteredRules = hasCreateAction && deploymentId
          ? rulesForDevice.filter(
              (f) => f.action === POLYGON_CONSTANTS.ACTION_TYPES.CREATE || f.deploymentid == null || f.deploymentid === deploymentId
            )
          : rulesForDevice;

        if (hasCreateAction) {
          // Unsaved alert path: user added alert via modal, not yet saved to server.
          // create mode: reverse to show newest first; update mode: sort by createdon ascending.
          if(action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {
            setRulesLists([...filteredRules].reverse());
          } else {
            setRulesLists([...filteredRules].sort((a, b) => new Date(a?.createdon || 0) - new Date(b?.createdon || 0)));
          }
          setIsModalOpen(false);
          setRuleDetails(false);
        } else {
          // Server fetch response path: all rules are from the API (no unsaved alerts).
          // deviceId required to scope rules — skip if ROI not yet created to prevent infinite loops.
          if (deviceId === undefined) {
            return;
          }
          // Normalize first rule: backfill captureVideoEvidence and timeZone if missing
          // (older rules may not have these fields set by the server).
          const normalizedRules = Array.isArray(filteredRules) && filteredRules.length > 0 && filteredRules[0].captureVideoEvidence === undefined
            ? [{ ...filteredRules[0], captureVideoEvidence: true, timeZone: filteredRules[0].timeZone ?? "ET" }, ...filteredRules.slice(1)]
            : filteredRules;
          const sortedRulesList = [...normalizedRules].sort((a, b) => new Date(a?.createdon || 0) - new Date(b?.createdon || 0));
          setRulesLists(sortedRulesList);
          setIsModalOpen(false);
          setRuleDetails(false);
        }
      }
    }
  }, [rulesList, action, cvAppData, cvAppCount]);
  const splitIntoPairs = (arr) => {
    let res = [];
    for (let i = 0; i < arr.length; i += 2) {
      res.push(arr.slice(i, i + 2));
    }
    return res;
  };

  const getFOVDeviceId = () => {
    if (!state) return null;

    const fovIdFromState = Array.isArray(state?.FOVId) ? state?.FOVId[0] : state?.FOVId;

    if (fovIdFromState) {
      return fovIdFromState;
    }

    if (!fovList || !Array.isArray(fovList)) return null;

    let matchingFov = fovList?.find((fov) => fov.parentdeviceid === state?.cameraId);

    if (matchingFov) {
      return matchingFov.id;
    }

    if (state?.fieldOfViews) {
      matchingFov = fovList.find((fov) => fov.name === state?.fieldOfViews);

      if (matchingFov) {
        return matchingFov.id;
      }
    }

    return null;
  };
  const createEERoi = (polyPoints) => {
    setLoading(true);
    const adjustPointsParent = adjustPolygonPoints(originalImageSize, splitIntoPairs(polyPoints[0].points), [minMaxXY?.maxX, minMaxXY?.maxY]);

    const adjustPointsLine = adjustPolygonPoints(originalImageSize, splitIntoPairs(polyPoints[2].points), [minMaxXY?.maxX, minMaxXY?.maxY]);
    const adjustPointsSplitter = adjustPolygonPoints(originalImageSize, splitIntoPairs(polyPoints[1].points), [minMaxXY?.maxX, minMaxXY?.maxY]);
    const spliClone = JSON.parse(JSON.stringify(adjustPointsLine));
    const splitPoly = spliClone.splice(2, 2);

    let payload = {
      accountname: activeSession?.accountId,
      // cameraid: state?.cameraId,
      // fovid:  Array.isArray(state?.FOVId) ? state?.FOVId[0] : state?.FOVId,
      // gwid: state?.companionId,
      polygon: {
        polygon: {
          frame: minMaxXY,
          edges: getPoints(adjustPointsParent)
        },
        direction: {
          splitter: getSplitPoints(spliClone, adjustPointsLine[2][0], adjustPointsLine[2][1]),
          in_polygon: {
            edges: getPoints(adjustPointsSplitter)
          }
        }
      },
      name: name
    };   
    payload.fovidentifier = {
      deviceid: getFOVDeviceId()
    };

    if (action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {
      payload.resourceidentifier = {
        deviceid: initData[0]?.roiId
      };
      // const res = undeployCvapp();
      if (Array.isArray(tagIds) && !tagIds.includes(siteId)) {
        tagIds.push(siteId);
      }
      payload.tagids = tagIds;
      let updateArr = updateRoi(initData[0]?.roiId);
      if (updateArr && updateArr.length) {
        updateArr[0].points = payload.polygon;
      }
      setRoiPolygon([...roiPolygonList, ...updateArr]);
      if (isRoiEdited) {
        dispatch(editRoiRequest(payload));
      } else if (isStatisticsEdited) {
        deployCvAppWithRoi(initData[0]?.roiId);
      }
      //setIsRoiEdited(false);
      setSelectedRoi(updateArr);
    } else {
      if (Array.isArray(submittedData) && !submittedData.includes(siteId)) {
        submittedData.push(siteId);
      }
      payload.tagids = submittedData && Array.isArray(submittedData[0]) ? submittedData[0] : submittedData;
      dispatch(createRoiRequest(payload));
    }
  };
  const updatePolygonState = (currentVal = "save") => {
    const polygons = JSON.parse(sessionStorage.getItem(POLYGON_CONSTANTS.SESSION_STORAGE_KEYS.POLYGONS_POINTS)) || [];
    const polyLength = polygons.length;

    // to avoid getPoints crash when polygons are empty after a failed ROI
    if (polyLength === 0) {
      return roiPolygonList || [];
    }

    setCreateNotification(true);
    const roiLabel = {
      groupName: cvAppData[cvAppCount].title,
      cvAppName: cvAppData[cvAppCount].value,
      label: `ROI${maxPolygons}-${cvAppData[cvAppCount].title}-${cvAppData[cvAppCount].value}`
    };
    const roiData =
      roiPolygonList && Object.keys(roiPolygonList).length
        ? [...roiPolygonList, ...[{ ...polygons[polyLength - 1], ...roiLabel }]]
        : [{ ...polygons[polyLength - 1], ...roiLabel }];
    // Early return for non-save calls to avoid unnecessary calculations
    if (currentVal !== "save") {
      return roiData;
    }
    const adjustPoints = adjustPolygonPoints(originalImageSize, polygons[polyLength - 1]?.points, [minMaxXY?.maxX, minMaxXY?.maxY]);
    let payload = {
      accountname: activeSession?.accountId,
      // cameraid: state?.cameraId,
      // fovid:  Array.isArray(state?.FOVId) ? state?.FOVId[0] : state?.FOVId,
      // gwid: state?.companionId,
      polygon: {
        polygon: {
          frame: minMaxXY,
          edges: getPoints(adjustPoints)
        }
      },
      name: name
    };
    if ((currentVal === "save" && action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) || clickStatus) {
      setLoading(true);
      payload.fovidentifier = {
        deviceid: getFOVDeviceId()
      };
      if (Array.isArray(submittedData) && !submittedData.includes(siteId)) {
        submittedData.push(siteId);
      }
      payload.tagids = submittedData && Array.isArray(submittedData[0]) ? submittedData[0].push(siteId) : submittedData;
      if (cvAppName == CVAPP_OBJECTBLUR || cvAppName == CVAPP_CAMERAADJUSTMENT) {
        deployCvAppWithRoi(fullRoiPolygonList.find((f) => f.customdata == undefined).id);
      } else {
        dispatch(createRoiRequest(payload));
        setSelectedRoi(roiData);
      }
    } else if (currentVal === "save" && action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {
      if ((isRoiEdited || isFinished) && !EXCLUDED_CVAPPS.includes(cvAppName)) {
        setLoading(true);
        payload.resourceidentifier = {
          deviceid: roiId
        };
        if (Array.isArray(tagIds) && !tagIds.includes(siteId)) {
          tagIds.push(siteId);
        }
        payload.tagids = tagIds;
        const updateArr = updateRoi(roiId);
        updateArr[0] && (updateArr[0].points = polygons[polyLength - 1]?.points);
        setRoiPolygon([...roiPolygonList, ...updateArr]);
        dispatch(editRoiRequest(payload));
        setIsRoiEdited(false);
        setSelectedRoi(roiData);
      } else if (isStatisticsEdited && !isAlertEdited) {
        if (Array.isArray(tagIds) && !tagIds.includes(siteId)) {
          tagIds.push(siteId);
        }
        dispatch(addTags(roiId, tagIds, siteId, roiStatsTagIds));
      }
      const ruleClone = rulesLists?.filter((rule) => rule.action === POLYGON_CONSTANTS.ACTION_TYPES.CREATE).reverse();
      ruleClone.map((rule, index) => {
        dispatch(
          createRule({
            ...rule,
            ...{
              action: isRoiEdited ? POLYGON_CONSTANTS.ACTION_TYPES.CREATE : "AlertUpdate",
              roiid: roiId,
              deploymentid: taggedRoiResponse?.id,
              companionid: state?.companionId
            }
          })
        );
      });
    }
  };

  const handleDeleteRoi = () => {
    let payload = {
      accountname: activeSession?.accountId,
      resourceidentifier: {
        deviceid: roiResponse?.refid
      }
    };
    dispatch(deleteRoiRequest(payload));
  };

  useEffect(() => {
    setTimeout(() => {
      if (createNotification && roiResponse === undefined) {
        setLoading(false);
        setCreateNotification(false);
        const notificationInfo = {
          type: POLYGON_CONSTANTS.NOTIFICATION_TYPES.ROI_CREATE_FAIL,
          priority: POLYGON_CONSTANTS.NOTIFICATION_PRIORITIES.CRITICAL,
          data: {
            title: "",
            subTitle: POLYGON_CONSTANTS.NOTIFICATION_MESSAGES.ROI_CREATE_FAIL
          },
          showNotification: true
        };
        dispatch(showNotificationBanner(notificationInfo));
      }
    }, 3000);
  }, [roiResponse]);

  useEffect(() => {
    if (!cvAppRoiLoading && taggedRoiResponse === undefined && roiResponse !== undefined) {
      setLoading(false);
      const notificationInfo = {
        type: POLYGON_CONSTANTS.NOTIFICATION_TYPES.ROI_CREATE_FAIL,
        priority: POLYGON_CONSTANTS.NOTIFICATION_PRIORITIES.CRITICAL,
        data: {
          subTitle: POLYGON_CONSTANTS.NOTIFICATION_MESSAGES.ROI_DEPLOY_FAIL_MESSAGE
        },
        showNotification: true,
        isDismissible: true,
        hideCloseButton: false,
      };
      dispatch(showNotificationBanner(notificationInfo));
      if (!EXCLUDED_CVAPPS.includes(cvAppName)) {
        handleDeleteRoi();
      }
    }
  }, [roiResponse, taggedRoiResponse, cvAppRoiLoading]);

  useEffect(() => {
    if (isRequiredParamsAvailable(advancedData)) {
      setIsErrorInAdvanceConfig(false);
    } else {
      setIsErrorInAdvanceConfig(true);
    }
    if (isRequiredParamsAvailable(standardAdvancedData)) {
      setIsErrorInStandardConfig(false);
    } else {
      setIsErrorInStandardConfig(true);
    }
  }, [advancedData, standardAdvancedData]);

  const fetchRules = (roiData, index, from) => {
    if (action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {
      return;
    }
    setTimeout(() => {
      selectedPolygon(roiData, index, from);
    }, POLYGON_CONSTANTS.TIMEOUT_DURATIONS.RULE_MODAL_OPEN);
    setRulesLists([]);
    setRulesListLoading(true);
    //Fetaching Rulues Data
    const rulePayload = {
      accountname: activeSession?.accountId,
      filter: {
        $selection: {
          deviceid: roiData?.roiId //cvAppData[index === "" ? cvAppCount : index]?.id,
        }
      }
    };
    dispatch(fetchRulesByDeviceIdRequest(rulePayload));
  };

  const fetchRoiList = () => {
    const payload = {
      accountname: activeSession?.accountId,
      // "gwid": state?.companionId,
      fovidentifiers: [
        {
          deviceid: getFOVDeviceId()
        }
      ],
      filter: {
        $expand: "fields,cvapp"
      }
    };

    const roiListApiResponse = async (payload, activeSession) => {
      setIsRoiListFetching(true);
      try {
        const roiListData = await listRoi(payload, activeSession);
        setFullRoiPolygonList(roiListData);
        //Filter the default roi that is created by the system without polygon data
        const data = roiListData.filter((item) => item.customdata && item.customdata.polygon);
        let filterPoints = [];
        data.map((item) => {
          const polygonPoints = transformPolygonData(item.customdata);

          if (polygonPoints && polygonPoints.length >= 3) {
            filterPoints.push({
              points: polygonPoints,
              roiId: item?.id,
              frame: item?.customdata,
              displayName: item?.cvapps?.[0]?.resources?.displayName,
              displayNameFull: item?.cvapps?.[0]?.resources?.displayNameFull
            });
          }
        });
       const uniqueRoi = getUniquePoints(filterPoints);

        setRoiPolygons(uniqueRoi);
      } catch (e) {
      } finally {
        setIsRoiListFetching(false);
      }
    };
    // dispatch(getAllRoiListWithCvApps());
    roiListApiResponse(payload, activeSession);
  };
  const matchedPolygon = (cvCount, refersh = false) => {
    // const matchedPolygon =
    //   roiPolygonList && roiPolygonList.length
    //     ? roiPolygonList.filter(
    //         (data) => data.groupName === cvAppData[cvCount]?.title //&& data?.cvAppName === cvAppData[cvCount]?.value
    //       )
    //     : [];
    if (refersh) {
      fetchRoiList();
    }
    const individualPolygon =
      roiPolygonList && roiPolygonList.length
        ? roiPolygonList.filter((data) => (action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE ? data?.roiId === cvAppData[cvCount]?.roiId : data?.cvAppName === cvAppData[cvCount]?.value))
        : [];
    // setRoiPolygons(matchedPolygon);
    setIndividual(individualPolygon);
    return individualPolygon;
  };

  const updateRoi = (roiId) => {
    const roiData = roiPolygonList && roiPolygonList.length ? roiPolygonList.filter((data) => data?.roiId === roiId) : [];
    // dispatch(setRoiPolygon(roiData));
    return roiData;
  };
  const previouslyDefinedCheck = (count = cvAppCount) => {
    const currentAppName = cvAppData[count]?.value;
    if (!roiPolygons?.length || !isExcludedOrEECvApp(currentAppName)) return false;
    return roiPolygons.some((rp) => {
      const appName = rp?.displayNameFull || rp?.displayName;
      return appName === currentAppName || isExcludedOrEECvApp(appName);
    });
  };
  const radioGroupsetting = (pcount = "") => {
    const count = pcount || pcount === 0 ? pcount : cvAppCount;
    const appTypeMatch = previouslyDefinedCheck(count);
    const radioGroups = [
      {
        ...POLYGON_CONSTANTS.RADIO_GROUP_CONFIG.FULL_SCREEN,
      }
    ];
    if (!EXCLUDED_CVAPPS.includes(cvAppData[count]?.value)) {
      radioGroups.push({
        ...POLYGON_CONSTANTS.RADIO_GROUP_CONFIG.CUSTOM_AREA,
      });
    }
    if (
      appTypeMatch &&
      roiPolygons?.length >= 1 &&
      !EXCLUDED_CVAPPS.includes(cvAppData[count]?.value)
    ) {
      radioGroups.push(POLYGON_CONSTANTS.RADIO_GROUP_CONFIG.PREVIOUSLY_DEFINED);
    }
    setRadioGroups(radioGroups);
  };
  const selectedPolygon = (roiData, index, from) => {
    const polygonPoints = action == POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && roiData?.originalPoints != undefined ? roiData?.originalPoints : roiData?.points;

    const maxX = roiData?.frame?.polygon?.frame?.maxX
      ? roiData?.frame?.polygon?.frame?.maxX
      : (roiData?.frame?.polygon?.polygon?.frame?.maxX ?? roiData?.frame?.polygon?.polygon?.frame?.maxX);
    const maxY = roiData?.frame?.polygon?.frame?.maxY
      ? roiData?.frame?.polygon?.frame?.maxY
      : (roiData?.frame?.polygon?.polygon?.frame?.maxY ?? roiData?.frame?.polygon?.polygon?.frame?.maxY);

    const adjustPoints = adjustPolygonPoints([maxX, maxY], polygonPoints, originalImageSize);
    setInitData(checkIfEntryExit() || from ? [{ roiId: roiData?.roiId, points: adjustPoints }] : [{ roiId: roiData?.roiId, points: [] }]);
    setSelectedIndex(index);
    if (checkIfEntryExit()) {
      setSelectedRoiId(roiData?.roiId);
      setEEPoints(roiData?.frame?.polygon);
    }
  };
  const addRoi = () => {
    const count = maxPolygons + 1;
    setMaxPolygons(count);
    setOpenModal(false);
    setShowFinish(true);
    setRulesLists([]);
    let polygonPoints = matchedPolygon(count, true);
    setInitData(initialData);
    const shouldShowCustomArea =
      action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE &&
      taggedRoiResponse?.status !== POLYGON_CONSTANTS.DEPLOYMENT_STATUS.DEPLOYING &&
      !EXCLUDED_CVAPPS.includes(cvAppName);
      handleBoxGroup(shouldShowCustomArea ? POLYGON_CONSTANTS.RADIO_BOX_OPTIONS.CUSTOM_AREA : POLYGON_CONSTANTS.RADIO_BOX_OPTIONS.FULL_SCREEN, polygonPoints);
    if (checkIfEntryExit()) {
      setClearRoi(false);
      setSubmittedData([]);
      setTimeout(() => {
        setClearRoi(true);
      }, POLYGON_CONSTANTS.TIMEOUT_DURATIONS.CLEAR_ROI);
      dispatch(setStatistic([]));
    }
  };
  const getTags = (tagids) => {
    const statistics = [];
    if (tagids?.length > 0)
      tagids?.map((id) => {
        statistics.push(getTagName(id, tagIdList));
      });
    return statistics;
  };
  const nextRoiApp = (index) => {
    // Clear Redux appearance state when moving to next ROI
    dispatch(clearAdvancedConfigAppearances());
    
    const count = index || index === 0 ? index : cvAppCount + 1;
    resetRoi(count);
  };
  const previousRoiApp = () => {
    // Clear Redux appearance state when moving to previous ROI
    dispatch(clearAdvancedConfigAppearances());
    
    const count = cvAppCount - 1;
    resetRoi(Math.max(0, count));
  };
  const resetRoi = (count, actFrom = "") => {
    setClearRoi(false);
    let polygonPoints = matchedPolygon(count);
    const cvname = cvAppData[count]?.value;
    const rlable = `ROI${1}-${cvAppData[count].title}-${cvAppData[count].value}`;
    initialData[0].cvAppName = cvname;
    initialData[0].label = rlable;
    setName(rlable);
    fetchRules(polygonPoints[0], count);
    setcvAppCount(Math.max(0, count));
    setOpenModal(false);
    radioGroupsetting(Math.max(0, count));
    handleBoxGroup(
      !EXCLUDED_CVAPPS.includes(cvname) && (action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE || actFrom) ? POLYGON_CONSTANTS.RADIO_BOX_OPTIONS.CUSTOM_AREA : POLYGON_CONSTANTS.RADIO_BOX_OPTIONS.FULL_SCREEN,
      polygonPoints,
      actFrom ? actFrom : "",
      Math.max(0, count)
    );
    // setDeleteState(false);
    setMaxPolygons(1);
    setIsFinished(false);
    // setInitData([]);
    setTimeout(() => {
      setDeleteState(true);
    }, POLYGON_CONSTANTS.TIMEOUT_DURATIONS.RULE_MODAL_OPEN);
    setPolygonsPoints([]);

    //FOR ENtry and Exit
    if (checkIfEntryExit(cvname)) {
      setClickStatus(false);
      setShow(false);
      setCheckRule(false);

      if (action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && !actFrom) {
        setRoiId(state?.roiList[count]?.roiId);
        mapDeploymentId(polygonPoints);
        setEEPoints(polygonPoints[0]?.frame?.polygon);
        if (polygonPoints && polygonPoints.length && polygonPoints[0]?.deployments && polygonPoints[0]?.deployments[0]?.config[ADVANCED_CONFIG.DEPLOY_PARAMETERS]) {
          const deploymentData = polygonPoints[0]?.deployments[0]?.config[ADVANCED_CONFIG.DEPLOY_PARAMETERS];
          if (deploymentData?.zone1 || deploymentData?.zone2) {
            const zones = [
              {
                groupName: rlable,
                statisticData: deploymentData["zone1"]?.length > 0 ? getTags(deploymentData["zone1"]) : ["Unused"],
                tags: deploymentData["zone1"]?.length > 0 ? deploymentData["zone1"] : ["-1"],
                eeAppStatus: "Zone1"
              },
              {
                groupName: rlable,
                statisticData: deploymentData["zone2"].length > 0 ? getTags(deploymentData["zone2"]) : ["Unused"],
                tags: deploymentData["zone2"].length > 0 ? deploymentData["zone2"] : ["-1"],
                eeAppStatus: "Zone2"
              }
            ];
            dispatch(setStatistic(zones));
          }
        }
      } else {

        setSubmittedData([]);
        dispatch(setStatistic([]));
        setRulesLists([]);
        setEePolygons([]);
        setTimeout(() => {
          setClearRoi(true);
        }, 1000);
      }
    }
    if (!checkIfEntryExit(cvname)) {
      setEePolygons([]);
    }
    //Except EE
    if (action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {
      setClickStatus(false);
      setShow(false);
      setCheckRule(false);
      dispatch(setStatistic([]));
      if (Array.isArray(rulesList) && rulesList.length > 0) {
        // Clear existing rules by dispatching empty array
        dispatch(fetchRulesByDeviceIdSuccess([]));
      }
      setSubmittedData([]);
      setRulesLists([]);

    } else {
      setRoiId(state?.roiList[count]?.roiId);
      mapDeploymentId(polygonPoints);
      setInitData([]);
      setIsRoiEdited(false);
    }
  };
  const mapDeploymentId = (deploymentsData) => {
    if (!deploymentsData || !deploymentsData[0]?.deployments) {
      return [];
    }
    const deployment = deploymentsData[0].deployments
      .filter((d) => d.appid === deploymentsData[0].cvappid)
      .find((l) => deploymentstatusList.includes(l.status));
    setDeploymentId(deployment?.id);
    return deployment;
  };
  const handleSubmit = () => {
    setSubmitted(true);
    if (eepolygons && eepolygons.length) {
      createEERoi(eepolygons);
    } else {
      updatePolygonState();
    }
    if ((isStandardConfigTampered || isAdvanceConfigTampered || isAlertEdited) && action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) {
      const deployment = mapDeploymentId(state?.roiUpdateData);
      deployCvAppWithRoi(undefined, deployment?.id);
    }
    setTimeout(() => {
      setSubmitted(false);
    }, POLYGON_CONSTANTS.TIMEOUT_DURATIONS.SUBMITTED);
  };
  const handleBoxGroup = (val, polygonPoints = "", buttonAct = "", pcount = 0) => {
    if (val === "full-screen" || EXCLUDED_CVAPPS.includes(cvAppName)) {
      setIsFullScreen(true);
    } else {
      setIsFullScreen(false);
    }
    setSelectRadioBox(val);
    let count = maxPolygons;
    setShowThambnail(false);
    if (val === POLYGON_CONSTANTS.RADIO_BOX_OPTIONS.CUSTOM_AREA) {
      setDeleteState(false);
      setIsFinished(false);
      if (state?.action == POLYGON_CONSTANTS.ACTION_TYPES.CREATE) {
        setInitData([]);
        setMaxPolygons(1);
        setTimeout(() => {
          setDeleteState(true);
        }, POLYGON_CONSTANTS.TIMEOUT_DURATIONS.RULE_MODAL_OPEN);
        // setTimeout(() => {
        //   setDeleteState(true);
        // }, 100);
      } else if (state?.action == POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && !EXCLUDED_CVAPPS.includes(cvAppData[pcount]?.value)) {
        if (buttonAct) {
          setInitData([]);
          setMaxPolygons(1);
          setTimeout(() => {
            setDeleteState(true);
          }, POLYGON_CONSTANTS.TIMEOUT_DURATIONS.RULE_MODAL_OPEN);
        } else {
          setTimeout(() => {
            setInitData([state?.roiList[pcount]]);
          }, 300);
        }
        selectedPolygon(state?.action == POLYGON_CONSTANTS.ACTION_TYPES.UPDATE ? state?.roiList[pcount] : initData, selectedIndex, "");
      }

      setSelectedIndex("");
    } else if (val === POLYGON_CONSTANTS.RADIO_BOX_OPTIONS.PREVIOUSLY_DEFINED) {
      //setInitData(state?.action == POLYGON_CONSTANTS.ACTION_TYPES.UPDATE ? [state?.roiList[pcount]] : []);
      setInitData([]);
      setMaxPolygons(0);
      setSelectedIndex("");
      setDeleteState(true);
      setShowThambnail(true);
    } else {
      count = count - 1;
      setMaxPolygons(Math.max(0, count));
      // setInitData(initialData);
      setTimeout(() => {
        setInitData(initialData);
      }, 300);
      setDeleteState(false);
      setShowThambnail(false);
      setIsFinished(true);
    }
    //setMaxPolygons(count);
    setShow(false);
  };

  const handleVisbility = (id) => {
    setDeleteState(false);
    //const arr = [];
    if (selectId.indexOf(id) === -1) {
      selectId.push(id);
    } else {
      selectId = selectId.filter((itemId) => itemId !== id);
    }
    setSelectId(selectId);

    const currentPolygon = updatePolygonState("currentState");
    //let filterPloygon = currentPolygon;
    let matchedPolygon = [];
    let matchedId = [];
    currentPolygon?.map((item) => {
      if (matchedId.indexOf(item.id) === -1 && selectId.indexOf(item.id) === -1 && item?.points?.length && item?.cvAppName === cvAppName && item?.cvAppName) {
        matchedPolygon.push(item);
        matchedId.push(item.id);
      }
    });

    if (matchedPolygon.length) {
      setDeleteState(true);
      setInitData(matchedPolygon);
    } else {
      setInitData([]);
      setDeleteState(true);
    }
  };
  // const handleStatistic = (e) => {
  //   const checked = e.target.checked;
  //   const value = e.target.defaultValue;
  //   if (checked) {
  //     selectStatistic.push(value);
  //   } else {
  //     selectStatistic.pop(value);
  //   }
  //   setSelectStatistic(selectStatistic);
  // };
  // const handleSubmitStatistic = () => {
  //   let appendData = [];
  //   selectStatistic.map((data) => {
  //     appendData.push({ children: data, value: data, selected: true });
  //   });
  //   setSubmittedData(appendData);
  //   setStatisticOpen(false);
  // };

  const handleFinish = () => {
    if (successMeg && ruleRes) {
      setSuccessMeg("");
      return;
    }
    // Clear Redux appearance state before navigating
    dispatch(clearAdvancedConfigAppearances());

    // Refresh ROI list with CV apps before navigating
    dispatch(getAllRoiListWithCvApps());
    //reset licenses count after creating ROI
    dispatch(fetchLicenses({"accountId":activeSession?.accountId , "origin":LICENSE_ORIGIN.POLYGON}));
    const page =
      location === "roilist"
        ? "/roi"
        : location === "eventsInfo"
          ? `/eventsInfo?eventid=${state?.eventId}`
          : `/cameraInfoPage?cameraId=${state?.cameraData?.id ? state?.cameraData?.id : stateInfo?.cameraId}`;
    const states =
      location === "roilist"
        ? {
            data: state?.cameraData,
            streamData: state?.streamData,
            FOVId: state?.FOVId,
            FOVSnapshot: state?.FOVSnapshot,
            fieldOfViews: state?.fieldOfViews,
            FOVName: state?.FOVName,
            originPage: state?.originPage ?? ""
          }
        : {};
    navigate(page, { state: states });
  };

  const handleCancel = () => {
    // Clear Redux appearance state before navigating back
    dispatch(clearAdvancedConfigAppearances());

    if (location === ASSOCIATE_STREAMS) {
      navigate("/appearanceDeployments", { state: { appearance: state?.appearance } });
      return;
    }

    const page = location === "roilist" ? "/roi" : location === "eventsInfo" ? `/eventsInfo?eventid=${state?.eventId}` : "/cvAppSub";
    const states =
      location === "roilist"
        ? {
            data: state?.cameraData,
            streamData: state?.streamData,
            FOVId: state?.FOVId,
            FOVSnapshot: state?.FOVSnapshot,
            fieldOfViews: state?.fieldOfViews,
            FOVName: state?.FOVName,
            originPage: state?.originPage ? state?.originPage : ""
          }
        : {
            cameraId: state?.cameraId,
            companionId: state?.companionId,
            FOVId: state?.FOVId,
            FOVImages: state?.FOVSnapshot,
            fieldOfViews: state?.fieldOfViews,
            FOVNames: state?.FOVNames,
            cameraname: state?.cameraname,
            siteSelected: state?.siteSelected,
            floorSelected: state?.floorSelected,
            areaSelected: state?.areaSelected,
            subAreaSelected: state?.subAreaSelected,
            action: state?.fromAction,
            cameradata: state?.cameradata,
            sku: state?.sku,
            roiList: state?.roiList,
            originPage: state?.originPage ? state?.originPage : ""
          };
    navigate(page, { state: states });
  };
  const filterAppsTotal = () => {
    const cvapps = (cvAppData && cvAppData?.filter((data) => data?.title === cvappGroup)) || [];
    return cvapps;
  };
  const filterApps = () => {
    const cvapps = cvAppData.filter((data) => data.title === cvappGroup && data.value !== cvAppData[cvAppCount].value) || [];
    return cvapps;
  };

  const handleAppsChanges = (appName) => {
    const cvIndex = (appName && cvAppData.findIndex((data) => data.value === appName)) || 0;
    const cvappIndex = cvIndex === -1 ? 0 : cvIndex;
    const currentPolygon = updatePolygonState("currentState");
    const currentRoi = (currentPolygon && currentPolygon.length && currentPolygon.filter((data) => data.cvAppName === cvAppData[cvAppCount].value)) || [];
    const ifSavedRoi = (roiPolygonList && roiPolygonList.length && roiPolygonList.filter((data) => data.value === appName)) || [];
    if (currentRoi?.length && currentRoi[0].points?.length && ifSavedRoi?.length === 0) {
      setLoading(false);
      setappChangeOpen(true);
      setSelectedCvIndex(cvappIndex);
    } else {
      setCaShow(false);
      nextRoiApp(cvappIndex);
    }
  };
  const filterRules = (type) => {
    const rulesList = rulesLists?.filter((data) => data.EEAppName === type) || [];
    return rulesList;
  };
  const showPermissionsBanner = () => {
    const notificationInfo = {
      type: POLYGON_CONSTANTS.PERMISSION_TYPES.NO_PERMISSION,
      priority: POLYGON_CONSTANTS.NOTIFICATION_PRIORITIES.CRITICAL,
      showNotification: true
    };
    dispatch(showNotificationBanner(notificationInfo));
  };
  return (
    <div className="App" ref={pageRef}>
      {(loading || cvAppRoiLoading) && <Loader active={true} fullscreen={true} disableFocusLock></Loader>}

      <div>
        <div className="vision-roi-col polygon-top-row">
          <div className="polygon-top-row__left">
            <Breadcrumbs surface="light">
              {location === ASSOCIATE_STREAMS ? (
                <>
                  <BreadcrumbItem>
                    <Link data-testid="polygon_enrolledAppearancesLink" to="/enrolledappearance" className="breadcrums-item_link">
                      Enrolled Appearances
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <Link
                      data-testid="polygon_associatedStreamsLink"
                      to="/appearanceDeployments"
                      state={{ appearance: state?.appearance }}
                      className="breadcrums-item_link"
                    >
                      {state?.appearanceName || "Appearance Name"}
                    </Link>
                  </BreadcrumbItem>
                </>
              ) : (
                <>
                  <BreadcrumbItem>
                    <Link data-testid="polygon_devicesLink" to="/devices" state={{ tabName: "Camera" }} className="breadcrums-item_link">
                      Cameras
                    </Link>
                  </BreadcrumbItem>
                  {location === "roilist" ? (
                    <>
                      {state && state.hasOwnProperty("originPage") && state?.originPage === "cameraDetails" ? (
                        <BreadcrumbItem>
                          <Link
                            data-testid="polygon_cameraInfoPageLink"
                            to={{
                              pathname: "/cameraInfoPage",
                              search: `?${createSearchParams({
                                cameraId: state?.cameraData?.id
                              })}`
                            }}
                            state={{ data: state?.cameraData }}
                            className="breadcrums-item_link"
                          >
                            {state?.cameraData?.name}
                          </Link>
                        </BreadcrumbItem>
                      ) : (
                        <></>
                      )}
                      <BreadcrumbItem>
                        <Link
                          data-testid="polygon_roiLink"
                          to={{
                            pathname: "/roi",
                            search: `?${createSearchParams({
                              cameraId: state?.cameraData?.id,
                              fovId: state?.FOVId
                            })}`
                          }}
                          state={{
                            data: state?.cameraData,
                            streamData: state?.streamData,
                            FOVId: state?.FOVId,
                            FOVSnapshot: state?.FOVSnapshot,
                            fieldOfViews: state?.fieldOfViews,
                            FOVName: state?.FOVName,
                            originPage: state?.originPage ? state?.originPage : ""
                          }}
                          className="breadcrums-item_link"
                        >
                          Regions of Interest
                        </Link>
                      </BreadcrumbItem>
                    </>
                  ) : location === "eventsInfo" ? (
                    <>
                      {state && state.hasOwnProperty("originPage") && state?.originPage === "eventsInfo" ? (
                        <BreadcrumbItem>
                          <Link
                            data-testid="polygon_cameraInfoPageLink"
                            to={{
                              pathname: "/eventsInfo",
                              search: `?${createSearchParams({
                                eventid: state?.eventId
                              })}`
                            }}
                            className="breadcrums-item_link"
                          >
                            Event Details
                          </Link>
                        </BreadcrumbItem>
                      ) : (
                        <></>
                      )}
                      {location !== "eventsInfo" ? (
                        <BreadcrumbItem>
                          <Link
                            data-testid="polygon_cvAppSubLink"
                            to="/cvAppSub"
                            state={{
                              cameraId: state?.cameraId,
                              companionId: state?.companionId,
                              FOVId: state?.FOVId,
                              FOVImages: state?.FOVSnapshot,
                              fieldOfViews: state?.fieldOfViews,
                              FOVNames: state?.FOVNames,
                              cameraname: state?.cameraname,
                              action: state?.fromAction,
                              cameradata: state?.cameradata,
                              sku: state?.sku,
                              originPage: state?.originPage ? state?.originPage : "",
                              roiList: state?.roiList
                            }}
                            className="breadcrums-item_link"
                          >
                            CV App Configuration
                          </Link>
                        </BreadcrumbItem>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <>
                      {state && state.hasOwnProperty("originPage") && state?.originPage === "cameraDetails" ? (
                        <BreadcrumbItem>
                          <Link
                            data-testid="polygon_cameraInfoPageLink"
                            to={{
                              pathname: "/cameraInfoPage",
                              search: `?${createSearchParams({
                                cameraId: state?.cameraId
                              })}`
                            }}
                            state={{
                              data: state?.cameradata?.find((item) => item?.id === state?.cameraId)
                                ? state?.cameradata?.find((item) => item?.id === state?.cameraId)
                                : {}
                            }}
                            className="breadcrums-item_link"
                          >
                            {state?.cameradata?.find((item) => item?.id === state?.cameraId)?.name}
                          </Link>
                        </BreadcrumbItem>
                      ) : (
                        <></>
                      )}
                      {location !== "eventsInfo" ? (
                        <BreadcrumbItem>
                          <Link
                            data-testid="polygon_cvAppSubLink"
                            to="/cvAppSub"
                            state={{
                              cameraId: state?.cameraId,
                              companionId: state?.companionId,
                              FOVId: state?.FOVId,
                              FOVImages: state?.FOVSnapshot,
                              fieldOfViews: state?.fieldOfViews,
                              FOVNames: state?.FOVNames,
                              cameraname: state?.cameraname,
                              action: state?.fromAction,
                              cameradata: state?.cameradata,
                              sku: state?.sku,
                              originPage: state?.originPage ? state?.originPage : "",
                              roiList: state?.roiList
                            }}
                            className="breadcrums-item_link"
                          >
                            CV App Configuration
                          </Link>
                        </BreadcrumbItem>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </>
              )}
              <BreadcrumbItem>Roi polygon configuration</BreadcrumbItem>
            </Breadcrumbs>

            <div className="polygon-title-pad">
              <Title size="small" primitive="h2" viewport="desktop">
                {state?.cameraData?.name}
              </Title>
            </div>
          </div>
          <div>
            <Button size={btnSize} use="secondary" width="100%" data-testid="polygon_cancelButton" onClick={() => handleCancel()}>
              Cancel {action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && <>edit</>}
            </Button>
          </div>
        </div>

        <div className="vision-roi-fullwidth">
          <div className="vision-roi-leftside">
            <div className="polygon-info-banner">
              <div className="polygon-info-banner__stream">
                <Body color="#ffffff" size="small" viewport="desktop" primitive="span">
                  Stream
                </Body>

                <Title size="small" color="#ffffff" primitive="h2" viewport="desktop">
                  {cvappGroup}
                </Title>
              </div>

              <div className="polygon-info-banner__cvapp">
                <Body size="small" color="#ffffff" viewport="desktop" primitive="span">
                  Computer Vision App
                </Body>
                <div className="polygon-info-banner__cvapp-inner">
                  <Icon name="group-family" color="#ffffff" size="large" />
                  <Title id="polygon-cvapp-name-title" size="small" color="#ffffff" primitive="h2" viewport="desktop">
                    {cvAppName}
                  </Title>
                </div>
              </div>
              {filterAppsTotal().length > 1 && (
                <div className="polygon-info-banner__change-pad">
                  <TextLink
                    type="standAlone"
                    surface="dark"
                    data-testid="polygon_changeAppButton"
                    onClick={() => {
                      setCaShow(!caShow);
                    }}
                  >
                    Change app
                  </TextLink>
                </div>
              )}
              {caShow && (
                <div className="vision-showhide vision-ca-pad">
                  <div
                    className="polygon-showhide-close polygon-ca-close-pad"
                    data-testid="polygon_closeIconButton"
                    onClick={() => {
                      setCaShow(false);
                    }}
                  >
                    <Icon name="close" color="#000000" size="small" />
                  </div>
                  <DropdownSelect
                    // label="CV Apps"
                    errorText="Select a CV App"
                    error={false}
                    disabled={false}
                    readOnly={false}
                    inlineLabel={false}
                    // helperText='Choose the CV App your reside in.'
                    helperTextPlacement="bottom"
                    tooltipTitle="Select a CV App"
                    data-testid="polygon_selectAppsDropdownSelect"
                    onChange={(e) => {
                      handleAppsChanges(e.target.value);
                    }}
                    tooltipContent="These are the CV Apps that are available."
                  >
                    <option>Select the Apps</option>
                    {filterApps().map((data) => {
                      return <option key={data.value}>{data.value}</option>;
                    })}
                  </DropdownSelect>
                </div>
              )}
            </div>
            <div className="polygon-canvas-container">
              <div className="vision-roi-col polygon-controls-row">
                <div className="polygon-controls-row__left">
                  <Title id="polygon-controls-title" size="small" primitive="h2" viewport="desktop">
                    Start by defining a region of interest
                  </Title>
                </div>
                <div className="polygon-controls-row__right">
                  <div className="polygon-controls-row__icon-btn">
                    {(selectRadioBox === "custom-area" ||
                      cvAppName === CVAPP_PEOPLE_COUNT_EE ||
                      cvAppName === CVAPP_VEHICLECOUNTEE ||
                      cvAppName === CVAPP_PARKINGOCCUPANCYEE ||
                      cvAppName === CVAPP_PARKINGOCCUPANCYEE_FULLNAME ||
                      cvAppName === CVAPP_PEOPLE_COUNT_EE_FULLNAME ||
                      cvAppName === CVAPP_VEHICLECOUNTEE_FULLNAME) &&
                      cvAppName !== CVAPP_OBJECTBLUR &&
                      cvAppName !== CVAPP_CAMERAADJUSTMENT && (
                        <Button size="small" use="secondary" width="100%" data-testid="polygon_clearButton" onClick={() => resetRoi(cvAppCount, "actFrom")}>
                          Clear
                        </Button>
                      )}
                  </div>
                  <div className="polygon-controls-row__textlink-wrap">
                    {individual && individual.length !== 0 && roiPolygons.length !== 0 && selectRadioBox === "custom-area" && (
                      <TextLink
                        size="small"
                        data-testid="polygon_showHideRoiButton"
                        onClick={() => {
                          setShow(true);
                        }}
                      >
                        Show/hide regions of interest
                      </TextLink>
                    )}
                  </div>
                  <div data-testid="polygon_syncIconButton" onClick={() => handlePairedSnapshot()} className="polygon-controls-row__icon-btn">
                    <Icon name="sync" size="small" color="#000000" />
                  </div>
                  {show && (
                    <div className="vision-showhide">
                      <div
                        className="polygon-showhide-close"
                        data-testid="polygon_closeIconButton"
                        onClick={() => {
                          setShow(false);
                        }}
                      >
                        <Icon name="close" color="#000000" size="small" />
                      </div>
                      <Title size="small" bold primitive="h2" viewport="desktop">
                        Show/hide regions of interest
                      </Title>
                      <Body size="medium" viewport="desktop" primitive="span">
                        Click the icon to show or hide the region of interest.{" "}
                      </Body>
                      <ModalBody>
                        {individual &&
                          individual.length &&
                          individual.map((roiItem, index) => {
                            return (
                              <div
                                key={roiItem.id ?? index}
                                data-testid="polygon_accessVisibitlityIconButton"
                                onClick={() => {
                                  handleVisbility(roiItem.id);
                                }}
                                className="polygon-visibility-item"
                              >
                                <Icon name={selectId.indexOf(roiItem.id) === -1 ? "accessibility" : "visibility-off"} color="#000000" size="medium" />
                                <Body size="medium" viewport="desktop" primitive="span">
                                  {roiItem.label ? roiItem.label : `ROI${maxPolygons}-${cvAppData[cvAppCount]?.title}-${cvAppName}`}
                                </Body>
                              </div>
                            );
                          })}
                      </ModalBody>
                    </div>
                  )}
                </div>
                {/* <Modal
      opened={true}
      disableOutsideClick={true}
      ariaLabel="Testing Modal"
      hideCloseButton={true}
    >
      <Title size="small"  bold primitive="h2" viewport="desktop">
      Show/hide regions of interest
       </Title>
       <Body size="medium" viewport="desktop" primitive="span">Click the icon to show or hide the region of interest. </Body>
      <ModalBody>
        <div style={{backgroundColor: "#F6F6F6", borderRadius:5, padding: "20px"}}>
        
        </div>
      
      </ModalBody>
      
    </Modal> */}
              </div>
              <div>
                <canvas ref={canvasRef} style={{ display: "none" }}></canvas>
                <img ref={imageRef} src={floorImage} alt="source" style={{ display: "none" }}></img>
              </div>
              {cvAppName !== CVAPP_PEOPLE_COUNT_EE &&
                cvAppName !== CVAPP_VEHICLECOUNTEE &&
                cvAppName !== CVAPP_PARKINGOCCUPANCYEE &&
                cvAppName !== CVAPP_PARKINGOCCUPANCYEE_FULLNAME &&
                cvAppName !== CVAPP_PEOPLE_COUNT_EE_FULLNAME &&
                cvAppName !== CVAPP_VEHICLECOUNTEE_FULLNAME && (
                  <PolygonAnnotation
                    bgImage={floorImage}
                    maxPolygons={maxPolygons}
                    polygonStyle={polygonStyle}
                    showLabel={showLabel}
                    imageSize={originalImageSize}
                    initialPolygonsLength={initData.length}
                    initialPolygons={initData}
                    setIsRoiEdited={setIsRoiEdited}
                    action={action}
                    setIsFinished={setIsFinished}
                    isFinishedROI={isFinished}
                    readOnly={isFullScreen}
                  >
                    <Toolbar
                      maxPolygons={maxPolygons}
                      setMaxPolygons={setMaxPolygons}
                      // updatePolygonState={(data)=>{updatePolygonState(data)}}
                      deleteState={deleteState}
                      config={polygonStyle}
                      setConfig={setPolygonStyle}
                      showLabel={showLabel}
                      setShowLabel={setShowLabel}
                    />
                  </PolygonAnnotation>
                )}
              {checkIfEntryExit() && (
                <EntryAndExit
                  videoSource={floorImage}
                  imageSize={{
                    width: originalImageSize[0],
                    height: originalImageSize[1]
                  }}
                  action={action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE ? action : ""}
                  resetpolygon={action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE ? eepoints : []}
                  eepolygons={eepolygons}
                  setEePolygons={setEePolygons}
                  setIsRoiEdited={setIsRoiEdited}
                  clearRoi={clearRoi}
                  zone2Color={zone2Color}
                  zone1Color={zone1Color}
                  lineColor={lineColor}
                  setIsPolygonExceedImageBoundary = {setIsPolygonExceedImageBoundary}
                />
              )}

              {cvAppName !== CVAPP_PEOPLE_COUNT_EE &&
                cvAppName !== CVAPP_VEHICLECOUNTEE &&
                cvAppName !== CVAPP_PARKINGOCCUPANCYEE &&
                cvAppName !== CVAPP_PARKINGOCCUPANCYEE_FULLNAME &&
                cvAppName !== CVAPP_PEOPLE_COUNT_EE_FULLNAME &&
                cvAppName !== CVAPP_VEHICLECOUNTEE_FULLNAME && (
                  <div className="polygon-radiogroup-wrap">
                    <RadioBoxGroup
                      id="polygon-roi-radiogroup"
                      childWidth={"100%"}
                      viewport={"desktop"}
                      orientation="horizontal"
                      value={selectRadioBox}
                      data-testid="polygon_cvAppsRadioGroupsBox"
                      onChange={(e) => {
                        handleBoxGroup(e.target.defaultValue, "", "", cvAppCount);
                      }}
                      data={radioGroups}
                    />
                    {(cvAppName === CVAPP_OBJECTBLUR || cvAppName === CVAPP_CAMERAADJUSTMENT) && (
                      <div className="full-screen-only">
                        <Icon name="info" size="small" color="#6F7171" />
                        {POLYGON_CONSTANTS.FULL_SCREEN_ONLY}
                      </div>
                    )}
                  </div>
                )}
              {checkIfEntryExit() && (
                <div className="polygon-thumbnail-hint">
                  <Body size="small" color="#000000" viewport="desktop" bold primitive="span">
                    <span>
                      <Icon name="warning" color="#000000" size="small" />
                    </span>
                    Tips
                  </Body>
                  <Body //styleName: [VDS] DeskTab/🖥 Body LG;
                    size="large"
                    color="#000000"
                    viewport="desktop"
                    primitive="span"
                  >
                    <ul>
                      <li>Draw a polygon that includes the threshold plus at least one foot on either side.</li>
                      <li>
                        The polygon will automatically be divided into Zone 1 and Zone 2. Move the center line by clicking and dragging on the endpoints or
                        center point in order to divide the zones correctly within the polygon.
                      </li>
                      {isPolygonExceedImageBoundary && <li style={{color:"red"}}>
                       {POLYGON_CONSTANTS.POLYGON_EXCEEDING_BOUNDARY}</li>}
                    </ul>
                  </Body>
                </div>
              )}
              {cvAppName !== CVAPP_PEOPLE_COUNT_EE &&
                cvAppName !== CVAPP_VEHICLECOUNTEE &&
                cvAppName !== CVAPP_PARKINGOCCUPANCYEE &&
                cvAppName !== CVAPP_PARKINGOCCUPANCYEE_FULLNAME &&
                cvAppName !== CVAPP_PEOPLE_COUNT_EE_FULLNAME &&
                cvAppName !== CVAPP_VEHICLECOUNTEE_FULLNAME &&
                roiPolygons &&
                roiPolygons.length !== 0 &&
                showThambnail && (
                  <div className="polygon-thumbnail-hint">
                    <Body size="small" color="#6F7171" viewport="desktop" primitive="span">
                      Select thumbnail to apply previously defined region of interest.
                    </Body>
                    <div className="vision-roi-poly-list" id="vision-roi">
                      {roiPolygons.map((roiData, index) => {
                        return (
                          <div
                            key={index}
                            id={index}
                            data-testid="polygon_floorImageListCheckbox"
                            onClick={() => {
                              setClickStatus(action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE ? true : false);
                              selectedPolygon(roiData, index, true);
                              setIsRoiEdited(true);
                              // fetchRules(roiData, index);
                            }}
                            className={selectedIndex === index ? "selected-thumb" : ""}
                          >
                            {
                              <List
                                videoSource={floorImage}
                                initialPolygons={roiData?.points}
                                imageSize={imageSize}
                                originalSize={[roiData?.frame, roiData?.frame]}
                              />
                            }
                            {selectedIndex === index && (
                              <div className="polygon-thumb-checkmark">
                                <Icon name="checkmark" color="#ffffff" />
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
            </div>
          </div>
          <div className="vision-roi-rightside-wrap">
            <div className="vision-roi-rightside">
              <div className="vision-roi-box polygon-box--h150">
                <div>
                  <Title size="small" primitive="h2" viewport="desktop">
                    Name region of interest
                  </Title>
                </div>
                {/* <Body size="small" viewport="desktop" primitive="span">
                Region of interest name
                </Body> */}
                <div className="polygon-right-name-box">
                  <Input
                    type="text"
                    label="Region of interest name"
                    placeholder=""
                    value={name}
                    required={true}
                    width="100%"
                    data-testid="polygon_roiNameInput"
                    onChange={(e) => {
                      setName(e.target.value);
                      setIsRoiEdited(true);
                    }}
                  />
                </div>
              </div>
              {/* <div
                className={action === 'update' ? "vision-roi-disable vision-roi-box" : "vision-roi-box"}
                style={{ paddingTop: "10px", height: "150px" }}
              >
                <div>
                  <Title size="small" primitive="h3" viewport="desktop">
                    Select People Count type
                    <Icon name="info" color="#000000" size="small" />
                  </Title>
                </div>
                <div className="vision-roi-col" style={{ marginTop: "15px" }}>
                  <RadioBoxGroup
                    childWidth={"100%"}
                    viewport={"desktop"}
                    orientation="horizontal"
                    //onChange={(e) => {handleBoxGroup(e)}}
                    data={[
                      {
                        id: "open-area",
                        value: "Open Area",
                        text: "Open Area",
                        type: "radiobox",
                        width: "180px",
                        subtext: "",
                      },
                      {
                        id: "entry-exit",
                        value: "Entry/Exit",
                        text: "Entry/Exit",
                        type: "radiobox",
                        width: "180px",
                        subtext: "",
                      },
                    ]}
                  />
                </div>
              </div> */}
              {/* OUT OF SCOPE — next pass: StandardForm.jsx responsive treatment */}
              {standardSchemaData?.scemaResourceData?.length !== 0 && (
                <StandardForm
                  advancedData={standardAdvancedData}
                  setAdvancedData={setStandardAdvancedData}
                  data={standardSchemaData}
                  setIsStandardConfigTampered={setIsStandardConfigTampered}
                  appName={cvAppName}
                  parameterKeyName="deploy-parameters"
                  ErrorInFormInput={ErrorInFormInput}
                  setErrorInFormInput={setErrorInFormInput}
                />
              )}

              {standardSchemaData?.scemaResourceData?.length !== 0 && (
                <SeparateTile
                  advancedData={standardAdvancedData}
                  setAdvancedData={setStandardAdvancedData}
                  data={standardSchemaData}
                  setIsStandardConfigTampered={setIsStandardConfigTampered}
                  appName={cvAppName}
                  parameterKeyName="deploy-parameters"
                  ErrorInFormInput={ErrorInFormInput}
                  setErrorInFormInput={setErrorInFormInput}
                  cvAppList={allCVAppList}
                  cvappid={cvappid}
                />
              )}

              {/* OUT OF SCOPE — next pass: Advanced Configuration Modal responsive treatment */}
              {isShowAdvancedConfig && (
                <div className="vision-roi-box" polygon-box--h108>
                  <div className="polygon-right-adv-box">
                    <Title size="small" primitive="h2" viewport="desktop">
                      Advanced configuration <span className="polygon-right-adv-optional">(Optional)</span>
                    </Title>
                    <div className="polygon-right-adv-links">
                      <Icon name="advanced-settings" color="#000000" size="large" />{" "}
                      <AdvancedConfiguration
                        advanceConfigRef={advanceConfigRef}
                        cvAppName={cvAppName}
                        ids={{ appid: cvappid, deviceid: roiResponse?.id }}
                        advancedData={advancedData}
                        setAdvancedData={setAdvancedData}
                        schemaData={schemaData}
                        resetFunc={resetToDefault}
                        setIsAdvanceConfigTampered={setIsAdvanceConfigTampered}
                        isAdvanceConfigTampered={isAdvanceConfigTampered}
                        ErrorInFormInput={ErrorInFormInput}
                        setErrorInFormInput={setErrorInFormInput}
                        action={action}
                        originalDeployConfig={deployParamsForUpdate}
                        siteId={siteId}
                        isRoiListFetching={isRoiListFetching}
                      />
                    </div>
                  </div>
                </div>
              )}
              {cvAppName !== CVAPP_PEOPLE_COUNT_EE &&
                cvAppName !== CVAPP_VEHICLECOUNTEE &&
                cvAppName !== CVAPP_PARKINGOCCUPANCYEE &&
                cvAppName !== CVAPP_PARKINGOCCUPANCYEE_FULLNAME &&
                cvAppName !== CVAPP_PEOPLE_COUNT_EE_FULLNAME &&
                cvAppName !== CVAPP_VEHICLECOUNTEE_FULLNAME &&
                stateInfo?.cvapps[cvAppCount]?.category === POLYGON_CONSTANTS.CATEGORY_TYPES.STATISTICS_APPS && (
                  <div
                    // className={
                    //   action === "update"
                    //     ? "vision-roi-disable vision-roi-box"
                    //     : "vision-roi-box"
                    // }
                    className="vision-roi-box polygon-box--min150"
                  >
                    <Statistics
                      roiLabel={roiLabel}
                      siteId={siteId}
                      cameraId={state?.cameraId}
                      appName={cvAppName ?? "NA"}
                      setIsStatisticsEdited={setIsStatisticsEdited}
                      action={action}
                      EEApp={false}
                      tagids={stateInfo?.cvapps[cvAppCount]?.tagids}
                      tagSaveStatus={tagSaveStatus}
                      setTagSaveStatus={setTagSaveStatus}
                      netCountWithTagList={netCountWithTagList}
                      setNetCountWithTagList={setNetCountWithTagList}
                    />
                  </div>
                )}
              {checkIfEntryExit() && (
                <div className="vision-roi-box polygon-box--min150 polygon-statistics-padtop">
                  <Title size="small" primitive="h2" viewport="desktop">
                    Statistics
                    <span className="polygon-statistics-title-icon">
                      <Icon name="info" color="#000000" size="large" />
                    </span>
                  </Title>
                  <div className="vision-roi-col polygon-statistics-inner">
                    <Body size="large" viewport="desktop" primitive="h2">
                      Select the location for Zone 1 and Zone 2 of this region of interest.
                    </Body>
                  </div>
                  <div className="vision-roi-col polygon-statistics-zones">
                    <div className="vision-roi-ee-right">
                      <div className="polygon-zone-label" style={{ backgroundColor: `${zone1Color}` }}>
                        <Body size="small" color="#ffffff" bold viewport="desktop" primitive="h2">
                          Zone 1
                        </Body>
                      </div>
                      <div className={eepolygons.length === 0 ? "vision-roi-disable" : ""}>
                        <Statistics
                          roiLabel={roiLabel}
                          siteId={siteId}
                          cameraId={state?.cameraId}
                          appName={cvAppName ?? "NA"}
                          setIsStatisticsEdited={setIsStatisticsEdited}
                          action={action}
                          EEApp="Zone1"
                          tagids={stateInfo?.deployParameters?.zone1}
                          tagSaveStatus={tagSaveStatus}
                          setTagSaveStatus={setTagSaveStatus}
                          netCountWithTagList={netCountWithTagList}
                          setNetCountWithTagList={setNetCountWithTagList}
                        />
                      </div>
                    </div>
                    <div>
                      <div className="polygon-zone-label" style={{ backgroundColor: `${zone2Color}` }}>
                        <Body size="small" color="#ffffff" bold viewport="desktop" primitive="h2">
                          Zone 2
                        </Body>
                      </div>
                      <div className={eepolygons.length === 0 ? "vision-roi-disable" : ""}>
                        <Statistics
                          roiLabel={roiLabel}
                          siteId={siteId}
                          cameraId={state?.cameraId}
                          appName={cvAppName ?? "NA"}
                          setIsStatisticsEdited={setIsStatisticsEdited}
                          action={action}
                          EEApp="Zone2"
                          tagids={stateInfo?.deployParameters?.zone2}
                          tagSaveStatus={tagSaveStatus}
                          setTagSaveStatus={setTagSaveStatus}
                          netCountWithTagList={netCountWithTagList}
                          setNetCountWithTagList={setNetCountWithTagList}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {cvAppName != CVAPP_OBJECTBLUR &&
                cvAppName !== CVAPP_PEOPLE_COUNT_EE &&
                cvAppName !== CVAPP_VEHICLECOUNTEE &&
                cvAppName !== CVAPP_PARKINGOCCUPANCYEE &&
                cvAppName !== CVAPP_PARKINGOCCUPANCYOA &&
                cvAppName !== CVAPP_PARKINGOCCUPANCYEE_FULLNAME &&
                cvAppName !== CVAPP_PEOPLE_COUNT_EE_FULLNAME &&
                cvAppName !== CVAPP_VEHICLECOUNTEE_FULLNAME &&
                cvAppName !== CVAPP_VEHICLECOUNTEE_FULLNAME && (
                  <Rules
                    selectedRule={selectedRule}
                    ruleDetails={ruleDetails}
                    rulesLists={rulesLists}
                    action={action}
                    openRuleModal={openRuleModal}
                    //isModalOpen={zoneType === "Zone2" ? false : isModalOpen}
                    isModalOpen={isModalOpen}
                    closeRuleModal={closeRuleModal}
                    isModalRuleOpen={isModalRuleOpen}
                    closeRuleRoiModal={closeRuleRoiModal}
                    cvAppName={cvAppName}
                    roiResponse={roiResponse}
                    cameraId={cameraId}
                    handleRuleResp={handleRuleResp}
                    state={state}
                    floorImage={floorImage}
                    cvappid={cvappid}
                    selectedRoiId={selectedRoiId}
                    setSelectedRule={setSelectedRule}
                    setRuleDetails={setRuleDetails}
                    EEAppName={""}
                    setZoneType={setZoneType}
                    zoneType={""}
                    data={
                      isAdvanceConfigTampered
                        ? {
                            max: advancedData?.config?.[ADVANCED_CONFIG.DEPLOY_PARAMETERS]?.distance_allowed,
                            min: originalSchemaData?.scemaTemplateData?.["distance_allowed"]?.minimum
                          }
                        : {
                            max: originalSchemaData?.scemaTemplateData?.["distance_allowed"]?.default,
                            min: originalSchemaData?.scemaTemplateData?.["distance_allowed"]?.minimum
                          }
                    }
                    tagIds={tagIds?.filter((tagId) => tagId !== siteId)}
                    loading={rulesListLoading}
                  />
                )}

              {(checkIfEntryExit() || cvAppName === CVAPP_PARKINGOCCUPANCYOA) && (
                <div className="vision-roi-box-last polygon-box--min50 polygon-statistics-padtop">
                  <Title size="small" primitive="h2" viewport="desktop">
                    Alerts
                    <span className="polygon-statistics-title-icon">
                      <Icon name="info" color="#000000" size="large" />
                    </span>
                  </Title>
                  <div className="polygon-right-adv-box">
                    <Body size="large" viewport="desktop" color="#6F7171" primitive="h2">
                      Please go to Settings/Alerts to create a {cvAppName} alert.
                    </Body>
                  </div>
                  {/* <div
                    className="vision-roi-col"
                    style={{ marginLeft: "10px", paddingTop: "20px" }}
                  >
                    <div className="vision-roi-ee-right">
                      <div
                        style={{
                          backgroundColor: `${zone1Color}`,
                          padding: "8px",
                          textAlign: "center",
                          width: "150px",
                        }}
                      >
                        <Body
                          size="small"
                          color="#ffffff"
                          bold
                          viewport="desktop"
                          primitive="h2"
                        >
                          Zone 1
                        </Body>
                      </div>
                      {rulesLists &&
                        filterRules("Zone1").length === 0 &&
                        zone1defaultColor === zone1Color && (
                          <>
                            <div
                              className="vision-roi-col"
                              style={{
                                paddingTop: "10px",
                                paddingBottom: "10px",
                              }}
                            >
                              <Body
                                size="small"
                                viewport="desktop"
                                primitive="h2"
                              >
                                There are no alerts currently applied to this
                                location.
                              </Body>
                            </div>
                            <div
                              className={
                                eepolygons.length === 0
                                  ? "vision-roi-disable"
                                  : ""
                              }
                            >
                              <Button
                                size={btnSize}
                                disabled={false}
                                use="primary"
                                onClick={() => {
                                  openRuleModal("Zone1");
                                }}
                              >
                                Add Alert
                              </Button>
                            </div>
                          </>
                        )}
                      {zone1defaultColor !== zone1Color && (
                        <div
                          className="vision-roi-col"
                          style={{ paddingTop: "10px", paddingBottom: "10px" }}
                        >
                          <Body size="small" viewport="desktop" primitive="h2">
                            Alerts cannot be created when “No zone” is selected.
                          </Body>
                        </div>
                      )}
                      {
                        <Rules
                          selectedRule={selectedRule}
                          ruleDetails={ruleDetails}
                          rulesLists={filterRules("Zone1")}
                          action={action}
                          openRuleModal={openRuleModal}
                          isModalOpen={
                            zoneType === "Zone1" ? isModalOpen : false
                          }
                          closeRuleModal={closeRuleModal}
                          isModalRuleOpen={isModalRuleOpen}
                          closeRuleRoiModal={closeRuleRoiModal}
                          cvAppName={cvAppName}
                          roiResponse={roiResponse}
                          cameraId={cameraId}
                          handleRuleResp={handleRuleResp}
                          state={state}
                          floorImage={floorImage}
                          cvappid={cvappid}
                          selectedRoiId={selectedRoiId}
                          setSelectedRule={setSelectedRule}
                          setRuleDetails={setRuleDetails}
                          EEAppName={"Zone1"}
                          setZoneType={setZoneType}
                          zoneType={zoneType}
                          data={
                            isAdvanceConfigTampered
                              ? {
                                  max: advancedData?.config?.[
                                    "deploy-parameters"
                                  ]?.distance_allowed,
                                  min: originalSchemaData?.scemaTemplateData?.[
                                    "distance_allowed"
                                  ]?.minimum,
                                }
                              : {
                                  max: originalSchemaData?.scemaTemplateData?.[
                                    "distance_allowed"
                                  ]?.default,
                                  min: originalSchemaData?.scemaTemplateData?.[
                                    "distance_allowed"
                                  ]?.minimum,
                                }
                          }
                        />
                      }
                    </div>
                    <div>
                      <div
                        style={{
                          backgroundColor: `${zone2Color}`,
                          padding: "8px",
                          textAlign: "center",
                          width: "150px",
                        }}
                      >
                        <Body
                          size="small"
                          color="#ffffff"
                          bold
                          viewport="desktop"
                          primitive="h2"
                        >
                          Zone 2
                        </Body>
                      </div>
                      {rulesLists &&
                        filterRules("Zone2").length === 0 &&
                        zone2defaultColor === zone2Color && (
                          <>
                            <div
                              className="vision-roi-col"
                              style={{
                                paddingTop: "10px",
                                paddingBottom: "10px",
                              }}
                            >
                              <Body
                                size="small"
                                viewport="desktop"
                                primitive="h2"
                              >
                                There are no alerts currently applied to this
                                location.
                              </Body>
                            </div>
                            <div
                              className={
                                eepolygons.length === 0
                                  ? "vision-roi-disable"
                                  : ""
                              }
                            >
                              <Button
                                size={btnSize}
                                disabled={false}
                                use="primary"
                                onClick={() => {
                                  openRuleModal("Zone2");
                                }}
                              >
                                Add Alert
                              </Button>
                            </div>
                          </>
                        )}
                      {zone2defaultColor !== zone2Color && (
                        <div
                          className="vision-roi-col"
                          style={{ paddingTop: "10px", paddingBottom: "10px" }}
                        >
                          <Body size="small" viewport="desktop" primitive="h2">
                            Alerts cannot be created when “No zone” is selected.
                          </Body>
                        </div>
                      )}
                      {
                        <Rules
                          selectedRule={selectedRule}
                          ruleDetails={ruleDetails}
                          rulesLists={filterRules("Zone2")}
                          action={action}
                          openRuleModal={openRuleModal}
                          isModalOpen={
                            zoneType === "Zone2" ? isModalOpen : false
                          }
                          closeRuleModal={closeRuleModal}
                          isModalRuleOpen={
                            zoneType === "Zone2" ? isModalRuleOpen : false
                          }
                          closeRuleRoiModal={closeRuleRoiModal}
                          cvAppName={cvAppName}
                          roiResponse={roiResponse}
                          cameraId={cameraId}
                          handleRuleResp={handleRuleResp}
                          state={state}
                          floorImage={floorImage}
                          cvappid={cvappid}
                          selectedRoiId={selectedRoiId}
                          setSelectedRule={setSelectedRule}
                          setRuleDetails={setRuleDetails}
                          EEAppName={"Zone2"}
                          setZoneType={setZoneType}
                          zoneType={zoneType}
                          data={
                            isAdvanceConfigTampered
                              ? {
                                  max: advancedData?.config?.[
                                    "deploy-parameters"
                                  ]?.distance_allowed,
                                  min: originalSchemaData?.scemaTemplateData?.[
                                    "distance_allowed"
                                  ]?.minimum,
                                }
                              : {
                                  max: originalSchemaData?.scemaTemplateData?.[
                                    "distance_allowed"
                                  ]?.default,
                                  min: originalSchemaData?.scemaTemplateData?.[
                                    "distance_allowed"
                                  ]?.minimum,
                                }
                          }
                        />
                      }
                    </div>
                  </div> */}
                </div>
              )}
              <div className={`vision-roi-cv-next ${cvAppName == CVAPP_OBJECTBLUR ? "polygon-cv-next--objectblur" : "polygon-cv-next--default"}`}>
                {openModal &&
                  (action === POLYGON_CONSTANTS.ACTION_TYPES.CREATE ||
                    action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE ||
                    taggedRoiResponse?.status === POLYGON_CONSTANTS.DEPLOYMENT_STATUS.DEPLOYING) && (
                    <Modal
                      opened={true}
                      key={`modal-${action}-${openModal}`}
                      disableOutsideClick={true}
                      fullScreenDialog={isModalFullScreen}
                      ariaLabel="Testing Modal"
                      hideCloseButton={true}
                      closeButton={
                        <div
                          className="polygon-modal-close-btn"
                          data-testid="newCameraInfo_deleteCameraModalTopCancelButton"
                          onClick={() => {
                            setOpenModal(false);
                            setRuleRes(false);
                            setIsStatisticsEdited(false);
                            setIsCvappDeploymentUpdated(false);
                            handleFinish();
                          }}
                        >
                          <Icon name="close" />
                        </div>
                      }
                    >
                      {/* <h4 style={{ marginBottom: "15px" }}></h4> */}
                      <Title size="large" bold primitive="h2" viewport="desktop">
                        {action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE ? "Edit submitted" : "Region of Interest submitted"}
                      </Title>
                      <ModalBody>
                        {error && (
                          <div className="polygon-modal-body-pad">
                            <Body size="large" viewport="desktop" primitive="h2" color="#EE0000">
                              <strong>{error}</strong>
                            </Body>
                          </div>
                        )}
                        {ruleRes && !isRoiEdited && !isStatisticsEdited && (
                          <div className="polygon-modal-body-pad">
                            <Body size="large" viewport="desktop" primitive="h2">
                              {successMeg}
                            </Body>
                          </div>
                        )}
                        {ruleRes && !isRoiEdited && isStatisticsEdited && (
                          <div className="polygon-modal-body-pad">
                            <Body size="large" viewport="desktop" primitive="h2">
                              Tag updated successfully.
                            </Body>
                          </div>
                        )}
                        {isCvappDeploymentUpdated && (
                          <div className="polygon-modal-body-pad" style={{ marginBottom: "20px" }}>
                            <Body size="large" viewport="desktop" primitive="h2">
                              Roi configuration updated successfully.
                            </Body>
                          </div>
                        )}
                        {!error && !ruleRes && action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && (
                          <>
                            {/* {setDisableRule(false)} */}
                            <div className="polygon-modal-body-pad--top">
                              <Body size="medium" viewport="desktop" primitive="h2">
                                The region of interest <strong>{name}</strong> has been submitted successfully. You can now receive
                                {cvAppData?.[cvAppCount]?.roiId} statistics and/or alerts for this region.
                              </Body>
                            </div>
                            {action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && !isSpecificCvApp(stateInfo?.cvapps, "extra features") && (
                              <div className="polygon-modal-body-pad">
                                <Body size="medium" viewport="desktop" primitive="h2">
                                  To add another region of interest for {cvAppData?.[cvAppCount]?.roiId} to this stream, select <strong>Add new</strong>. If you
                                  are finished adding regions of interest for {cvAppData?.[cvAppCount]?.roiId} to this stream, select <strong>Next app</strong>.
                                </Body>
                              </div>
                            )}
                          </>
                        )}
                        {!error && !ruleRes && action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && !EXCLUDED_CVAPPS.includes(cvAppName) && (
                          <>
                            <div className="polygon-modal-success-banner">
                              <Body size="small" bold viewport="desktop" primitive="h2">
                                Submit successful
                              </Body>
                              <Body size="small" viewport="desktop" primitive="h2">
                                The edits to the region of interest <strong>{roiLabel}</strong> has been submitted successfully.
                              </Body>
                            </div>
                            {action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && (
                              <div className="polygon-modal-body-pad">
                                <Body size="medium" viewport="desktop" primitive="h2">
                                  To add another region of interest for {cvAppData[cvAppCount]?.value} to this stream, select <strong>Add new</strong>. If you
                                  are finished adding regions of interest for {cvAppData[cvAppCount]?.value} to this stream, select <strong>Edit next</strong>{" "}
                                  to edit the next region of interest selected.
                                </Body>
                              </div>
                            )}
                          </>
                        )}
                      </ModalBody>
                      <div className="polygon-modal-actions">
                        {" "}
                        {(error || ruleRes || action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE) && (
                          <Button
                            size={btnSize}
                            use="primary"
                            width="100%"
                            data-testid="polygon_closeButton"
                            onClick={() => {
                              setOpenModal(false);
                              setRuleRes(false);
                              setIsStatisticsEdited(false);
                              setIsCvappDeploymentUpdated(false);
                              handleFinish();
                            }}
                          >
                            Close
                          </Button>
                        )}
                        {!error && !ruleRes && action !== POLYGON_CONSTANTS.ACTION_TYPES.UPDATE && (
                          <>
                            {!isSpecificCvApp(stateInfo?.cvapps, "extra features") && (
                              <Button size={btnSize} use="primary" width="100%" data-testid="polygon_addNewButton" onClick={() => addRoi()}>
                                Add New
                              </Button>
                            )}
                            <Button
                              size={btnSize}
                              use={isSpecificCvApp(stateInfo?.cvapps, "extra features") ? "secondary" : "primary"}
                              width="100%"
                              data-testid="polygon_editFinishSkipButton"
                              onClick={(e) => {
                                if (pageRef.current) {
                                  pageRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
                                } else if (typeof window !== "undefined") {
                                  window.scrollTo({ top: 0, behavior: "smooth" });
                                }
                                cvAppCount === cvAppData.length - 1 ? handleFinish() : nextRoiApp();
                              }}
                            >
                              {action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE
                                ? POLYGON_CONSTANTS.BUTTON_LABELS.EDIT_NEXT
                                : cvAppCount === cvAppData.length - 1
                                  ? POLYGON_CONSTANTS.BUTTON_LABELS.FINISH
                                  : POLYGON_CONSTANTS.BUTTON_LABELS.SKIP_TO_NEXT_APP}
                            </Button>
                          </>
                        )}
                      </div>
                    </Modal>
                  )}
                <div className="vision-roi-col polygon-submit-row">
                  {submitted && (
                    <>
                      <ClipLoader size={15} color="#ffffff" />{" "}
                      <Body size="medium" color="#ffffff" viewport="desktop" primitive="h2">
                        This region of interest is submitted
                      </Body>
                    </>
                  )}
                  {!submitted && (
                    <Button
                      size={btnSize}
                      disabled={
                        isDisabled(rulesList, submittedData, statisticDatas, cvAppData[cvAppCount]?.category) ||
                        (Array.isArray(ErrorInFormInput) && ErrorInFormInput.length !== 0)
                      }
                      use="primary"
                      surface="dark"
                      data-testid="polygon_saveSubmitRoiButton"
                      onClick={(e) => handleSubmit()}
                    >
                      {action === POLYGON_CONSTANTS.ACTION_TYPES.UPDATE ? POLYGON_CONSTANTS.BUTTON_LABELS.SAVE : POLYGON_CONSTANTS.BUTTON_LABELS.SUBMIT} region
                      of interest
                    </Button>
                  )}
                </div>
              </div>
              <div className="vision-roi-col polygon-nav-row">
                <TextLinkCaret
                  surface="light"
                  disabled={cvAppCount === 0 ? true : false}
                  iconPosition="left"
                  data-testid="polygon_previousRoiTextCaretLink"
                  onClick={(e) => previousRoiApp()}
                >
                  Previous ROI
                </TextLinkCaret>

                <TextLinkCaret
                  surface="light"
                  disabled={cvAppCount === cvAppData.length - 1 && showFinish ? true : false}
                  iconPosition="right"
                  data-testid="polygon_finishSaveToNextRoiTextCaretLink"
                  onClick={(e) => {
                    cvAppCount === cvAppData.length - 1 ? handleFinish() : nextRoiApp();
                  }}
                >
                  {cvAppCount === cvAppData.length - 1 ? POLYGON_CONSTANTS.BUTTON_LABELS.FINISH : POLYGON_CONSTANTS.BUTTON_LABELS.SKIP_TO_NEXT_ROI}
                </TextLinkCaret>
              </div>
              <div>
                <Modal
                  opened={appChangeOpen}
                  disableOutsideClick={true}
                  fullScreenDialog={isModalFullScreen}
                  hideCloseButton={true}
                  data-testid="polygon_unsavedChangesConfirmationModal"
                  onClick={() => {
                    setappChangeOpen(false);
                  }}
                >
                  <ModalBody>
                    <div className="polygon-modal-body-pad">
                      <Body size="large" viewport="desktop" primitive="h2">
                        You have unsaved changes. Are you want to leave this ROI changes?
                      </Body>
                    </div>
                  </ModalBody>
                  <div className="polygon-confirm-actions">
                    <Button
                      size={btnSize}
                      use="primary"
                      width="100%"
                      data-testid="polygon_confirmButton"
                      onClick={() => {
                        nextRoiApp(selectCvIndex);
                        setappChangeOpen(false);
                        setCaShow(false);
                      }}
                    >
                      Confirm
                    </Button>
                    <Button
                      size={btnSize}
                      use="secondary"
                      width="100%"
                      data-testid="polygon_cancelButton"
                      onClick={() => {
                        //handleSubmitStatistic();
                        setappChangeOpen(false);
                        setCaShow(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnotationDraw;
